import {
  GraphQLResolveInfo,
  GraphQLScalarType,
  GraphQLScalarTypeConfig,
} from 'graphql';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type RequireFields<T, K extends keyof T> = {
  [X in Exclude<keyof T, K>]?: T[X];
} & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A Type representing a LocalDate (without time) */
  LocalDate: any;
  /** A Type representing an OffsetDateTime */
  OffsetDateTime: any;
  /** Generic object */
  Object: any;
  /** A Type representing a LocalTime */
  LocalTime: any;
  /** A Type representing a Set */
  Set: any;
  /** A Type representing a Set of PrivacyOption */
  PrivacyOptionsSet: any;
};

export type AemFormsHandlerConfig = {
  frontend: Maybe<Scalars['Object']>;
};

export type AemFormsResourcesConfiguration = {
  frontend: Maybe<Scalars['Object']>;
};

export type AppointmentCalendar = {
  closingPeriods: Maybe<Array<Maybe<ClosingDatePeriod>>>;
  initialUnavailableDays: Scalars['Int'];
  daysToAssertTimePeriodAvailability: Maybe<Scalars['Int']>;
  timePicker: Maybe<TimePicker>;
  weekStartsOn: Maybe<Scalars['String']>;
};

export type AppointmentStatusWrapper_BookingStatus = {
  status: Maybe<Scalars['String']>;
};

export type AppointmentStatusWrapper_RequestStatus = {
  status: Maybe<Scalars['String']>;
};

export enum AppointmentType {
  RENT = 'RENT',
  TEST_DRIVE = 'TEST_DRIVE',
}

export type BookingAppointmentCancellation = {
  cancellationMessage: Maybe<Scalars['String']>;
  context: Maybe<Scalars['String']>;
  domain: Maybe<Scalars['String']>;
  countryCode: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  language: Maybe<Scalars['String']>;
};

export type BookingAppointmentCancellationInput = {
  countryCode: Maybe<Scalars['String']>;
  language: Maybe<Scalars['String']>;
  context: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  cancellationMessage: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
};

export type BookingAppointmentConfirmation = {
  appointmentMessage: Maybe<Scalars['String']>;
  appointmentType: Maybe<AppointmentType>;
  countryCode: Maybe<Scalars['String']>;
  dealer: Maybe<Dealer>;
  id: Maybe<Scalars['String']>;
  language: Maybe<Scalars['String']>;
  schedule: Maybe<SchedulePreference>;
  status: Maybe<BookingStatus>;
  vehicle: Maybe<TestDriveVehicle>;
  onlineStoreDeeplink: Maybe<Scalars['String']>;
};

export type BookingAttemptPreferencesInput = {
  engine: Maybe<EngineInput>;
  fuelType: Maybe<FuelType>;
  weightCategory: Maybe<WeightCategory>;
  onlineCode: Maybe<Scalars['String']>;
  vehicleId: Maybe<Scalars['String']>;
  modelSeriesId: Maybe<Scalars['String']>;
  motorisationId: Maybe<Scalars['String']>;
  wheelBase: Maybe<WheelBaseInput>;
  driveType: Maybe<DriveType>;
  schedule: Maybe<SchedulePreferenceInput>;
  transmission: Maybe<Transmission>;
  vehicleTypes: Maybe<Scalars['Set']>;
};

export type BookingDuration = {
  hours: Maybe<Scalars['Int']>;
  minutes: Maybe<Scalars['Int']>;
};

export type BookingDurationTimeSlots = {
  duration: Maybe<BookingDuration>;
  timeSlotInterval: Maybe<Array<Maybe<TimeSlotInterval>>>;
};

export type BookingOption = {
  bookingAvailableDays: Maybe<Array<Maybe<DayAvailability>>>;
  bookingTimeSlots: Maybe<Array<Maybe<TimeSlot>>>;
  dealer: Maybe<Dealer>;
  vehicle: Maybe<TestDriveVehicle>;
};

export enum BookingStatus {
  BOOKED = 'BOOKED',
  CANCELLED = 'CANCELLED',
  DONE = 'DONE',
  PENDING = 'PENDING',
}

export type BusinessHoursPeriod = {
  closingTime: Maybe<Scalars['LocalTime']>;
  openingTime: Maybe<Scalars['LocalTime']>;
};

export type CarbonFootprint = {
  co2EmissionAndFuelConsumption: Maybe<Co2EmissionAndFuelConsumption>;
  energyEfficiency: Maybe<EnergyEfficiency>;
  frontend: Maybe<Scalars['Object']>;
};

export enum Category {
  COMMERCIAL = 'COMMERCIAL',
  PRIVATE = 'PRIVATE',
}

export type CiasClaim = {
  aud: Maybe<Scalars['String']>;
  ciamUid: Maybe<Scalars['String']>;
  exp: Maybe<Scalars['String']>;
  iat: Maybe<Scalars['String']>;
  iss: Maybe<Scalars['String']>;
  jti: Maybe<Scalars['String']>;
  sub: Maybe<Scalars['String']>;
};

export type CiasClaimByEmail = {
  userId: Maybe<Scalars['String']>;
};

export type ClosingDatePeriod = {
  endDate: Maybe<Scalars['LocalDate']>;
  startDate: Maybe<Scalars['LocalDate']>;
};

export type Co2EmissionAndFuelConsumption = {
  metricType: Maybe<Scalars['String']>;
  visible: Maybe<Scalars['Boolean']>;
};

export enum CommunicationOption {
  EMAIL = 'EMAIL',
  EMAIL_NO = 'EMAIL_NO',
  EMAIL_YES = 'EMAIL_YES',
  PHONE = 'PHONE',
  PHONE_NO = 'PHONE_NO',
  PHONE_YES = 'PHONE_YES',
  POST = 'POST',
  POST_NO = 'POST_NO',
  POST_YES = 'POST_YES',
  SMS = 'SMS',
  SMS_NO = 'SMS_NO',
  SMS_YES = 'SMS_YES',
  WHATSAPP = 'WHATSAPP',
  WHATSAPP_NO = 'WHATSAPP_NO',
  WHATSAPP_YES = 'WHATSAPP_YES',
}

export type Coordinates = {
  latitude: Maybe<Scalars['Float']>;
  longitude: Maybe<Scalars['Float']>;
  timeZone: Maybe<Scalars['String']>;
};

export type CustomerAddressInput = {
  houseNumber: Maybe<Scalars['String']>;
  street: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
  city: Maybe<Scalars['String']>;
};

export type CustomerContactsInput = {
  mobilePhone: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
  email: Maybe<Scalars['String']>;
};

export type CustomizableBookingCustomerInput = {
  salutation: Maybe<Salutation>;
  title: Maybe<Title>;
  companyName: Maybe<Scalars['String']>;
  ciamId: Maybe<Scalars['String']>;
  middleName: Maybe<Scalars['String']>;
  lastName: Maybe<Scalars['String']>;
  localizedFirstName: Maybe<Scalars['String']>;
  address: Maybe<CustomerAddressInput>;
  declarationOfConsent: Maybe<DeclarationOfConsentInput>;
  vatNumber: Maybe<Scalars['String']>;
  localizedLastName: Maybe<Scalars['String']>;
  contacts: Maybe<CustomerContactsInput>;
  firstName: Maybe<Scalars['String']>;
  driverLicense: Maybe<Scalars['String']>;
  profileType: Maybe<ProfileType>;
};

export type CustomizableRequestCustomerInput = {
  salutation: Maybe<Salutation>;
  ciamId: Maybe<Scalars['String']>;
  localizedLastName: Maybe<Scalars['String']>;
  declarationOfConsent: Maybe<DeclarationOfConsentInput>;
  profileType: Maybe<ProfileType>;
  lastName: Maybe<Scalars['String']>;
  driverLicense: Maybe<Scalars['String']>;
  firstName: Maybe<Scalars['String']>;
  localizedFirstName: Maybe<Scalars['String']>;
  pickMeUpAddress: Maybe<CustomerAddressInput>;
  middleName: Maybe<Scalars['String']>;
  address: Maybe<CustomerAddressInput>;
  contacts: Maybe<CustomerContactsInput>;
  title: Maybe<Title>;
  companyName: Maybe<Scalars['String']>;
  vatNumber: Maybe<Scalars['String']>;
};

export type DayAvailability = {
  available: Scalars['Boolean'];
  date: Maybe<Scalars['LocalDate']>;
};

export type DayTimePeriod = {
  endTime: Maybe<Scalars['LocalTime']>;
  id: Maybe<Scalars['String']>;
  startTime: Maybe<Scalars['LocalTime']>;
};

export type Dealer = {
  address: Maybe<DealerAddress>;
  booking: Scalars['Boolean'];
  companyId: Maybe<Scalars['String']>;
  computedName: Maybe<Scalars['String']>;
  contacts: Maybe<DealerContacts>;
  departmentClosingPeriods: Maybe<Scalars['Object']>;
  departmentSchedules: Maybe<Scalars['Object']>;
  id: Maybe<Scalars['String']>;
};

export type DealerAddress = {
  computedAddress: Maybe<Scalars['String']>;
  coordinates: Maybe<Coordinates>;
  city: Maybe<Scalars['String']>;
  distance: Maybe<Scalars['String']>;
  unit: Maybe<Scalars['String']>;
};

export type DealerContacts = {
  email: Maybe<Scalars['String']>;
  phone: Maybe<Scalars['String']>;
};

export type DealerSearch = {
  frontend: Maybe<Scalars['Object']>;
};

export type DealerSearchMatch = {
  dealers: Maybe<Array<Maybe<Dealer>>>;
  total: Scalars['Int'];
};

export type DeclarationOfConsentInput = {
  communicationOptions: Maybe<Scalars['Set']>;
  privacyOptions: Maybe<Scalars['PrivacyOptionsSet']>;
};

export type DmoBooking = {
  active: Scalars['Boolean'];
  minimumDuration: Scalars['Int'];
  pickUpDelay: Scalars['Int'];
  returnDelay: Scalars['Int'];
  timeSlotInterval: Scalars['Int'];
  whiteList: Maybe<WhiteList>;
};

export type DriverLicenseNotifications = {
  active: Scalars['Boolean'];
  unit: Maybe<Scalars['String']>;
  weight: Scalars['Float'];
};

export enum DriveType {
  AWD = 'AWD',
  FWD = 'FWD',
  RWD = 'RWD',
}

export type EnergyEfficiency = {
  visible: Maybe<Scalars['Boolean']>;
};

export type Engine = {
  powerInHp: Maybe<TechnicalMetric>;
  powerInKw: Maybe<TechnicalMetric>;
  type: Maybe<EngineType>;
};

export type EngineInput = {
  powerInHp: Maybe<TechnicalMetricInput>;
  type: Maybe<EngineType>;
  powerInKw: Maybe<TechnicalMetricInput>;
};

export enum EngineType {
  COMBUSTION = 'COMBUSTION',
  ELECTRIC = 'ELECTRIC',
  FUEL_CELL = 'FUEL_CELL',
  MILD_HYBRID = 'MILD_HYBRID',
  PLUGIN_HYBRID = 'PLUGIN_HYBRID',
}

export type FootNotesConfiguration = {
  frontend: Maybe<Scalars['Object']>;
};

export type FormConfiguration = {
  frontend: Maybe<Scalars['Object']>;
};

export type FuelConsumptionMetrics = {
  electric: Maybe<TechnicalRangeMetric>;
  fossil: Maybe<TechnicalRangeMetric>;
};

export enum FuelType {
  DIESEL = 'DIESEL',
  ELECTRIC = 'ELECTRIC',
  ETHANOL = 'ETHANOL',
  HYBRID = 'HYBRID',
  HYDROGEN = 'HYDROGEN',
  PETROL = 'PETROL',
}

export enum Group {
  PASSENGER_CAR = 'PASSENGER_CAR',
  SMART = 'SMART',
  VAN = 'VAN',
}

export type Images = {
  defaultImage: Maybe<Scalars['String']>;
  fallbackImages: Maybe<Scalars['Object']>;
};

export type InfoBannerConfiguration = {
  frontend: Maybe<Scalars['Object']>;
};

export enum LifeCycle {
  ARCHIVED = 'ARCHIVED',
  FOR_SALE = 'FOR_SALE',
  RUNOUT = 'RUNOUT',
}

export type LocationSuggestion = {
  label: Maybe<Scalars['String']>;
  locationId: Maybe<Scalars['String']>;
  postalCode: Maybe<Scalars['String']>;
};

export type Maintenance = {
  active: Scalars['Boolean'];
};

export type MinimumDriverAgeNotifications = {
  active: Scalars['Boolean'];
};

export type Model = {
  bodyStyleId: Maybe<Scalars['String']>;
  bodyStyleName: Maybe<Scalars['String']>;
  categories: Maybe<Array<Maybe<Category>>>;
  classId: Maybe<Scalars['String']>;
  className: Maybe<Scalars['String']>;
  fuelTypes: Maybe<Array<Maybe<FuelType>>>;
  group: Maybe<Group>;
  id: Maybe<Scalars['String']>;
  images: Maybe<Images>;
  motorisations: Maybe<Array<Maybe<Motorisation>>>;
  name: Maybe<Scalars['String']>;
  transmissions: Maybe<Array<Maybe<Transmission>>>;
  vehicleTypeOptions: Maybe<Array<Maybe<VehicleType>>>;
  weightCategories: Maybe<Array<Maybe<WeightCategory>>>;
  lifeCycle: Maybe<LifeCycle>;
};

export type ModelFilterInput = {
  classId: Maybe<Scalars['String']>;
  bodyStyleId: Maybe<Scalars['String']>;
};

export type ModelSelection = {
  carbonFootprint: Maybe<CarbonFootprint>;
  frontend: Maybe<Scalars['Object']>;
  onlineCode: Maybe<OnlineCode>;
  whiteList: Maybe<WhiteList>;
};

export type ModelSeriesMapper = {
  frontend: Maybe<Scalars['Object']>;
};

export type Motorisation = {
  baumuster: Maybe<Scalars['String']>;
  booking: Scalars['Boolean'];
  categories: Maybe<Array<Maybe<Category>>>;
  changeYear: Maybe<Scalars['String']>;
  co2Emission: Maybe<TechnicalRangeMetric>;
  driveType: Maybe<DriveType>;
  energyEfficiencyClass: Maybe<Scalars['Object']>;
  engine: Maybe<Engine>;
  fuelConsumption: Maybe<FuelConsumptionMetrics>;
  fuelType: Maybe<FuelType>;
  id: Maybe<Scalars['String']>;
  images: Maybe<Images>;
  lifeCycle: Maybe<LifeCycle>;
  modelSeriesId: Maybe<Scalars['String']>;
  modelYear: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  nationalSalesType: Maybe<Scalars['String']>;
  transmissions: Maybe<Array<Maybe<Transmission>>>;
  vehicleTypes: Maybe<Array<Maybe<VehicleType>>>;
  weight: Maybe<Weight>;
  weightCategory: Maybe<WeightCategory>;
  wheelBase: Maybe<WheelBase>;
};

export type Mutation = {
  createRentalBooking: Maybe<AppointmentStatusWrapper_BookingStatus>;
  createTestDriveBookingReschedule: Maybe<AppointmentStatusWrapper_BookingStatus>;
  createRequest: Maybe<AppointmentStatusWrapper_RequestStatus>;
  cancelRentalBooking: Maybe<BookingAppointmentCancellation>;
  cancelTestDriveBooking: Maybe<BookingAppointmentCancellation>;
  createTestDriveBooking: Maybe<AppointmentStatusWrapper_BookingStatus>;
};

export type MutationCreateRentalBookingArgs = {
  rentalBookingAppointmentAttempt: RentalBookingAppointmentAttemptInput;
};

export type MutationCreateTestDriveBookingRescheduleArgs = {
  testDriveBookingReschedule: TestDriveBookingRescheduleInput;
};

export type MutationCreateRequestArgs = {
  testDriveRequestAttempt: TestDriveRequestAttemptInput;
};

export type MutationCancelRentalBookingArgs = {
  bookingAppointmentCancellation: BookingAppointmentCancellationInput;
};

export type MutationCancelTestDriveBookingArgs = {
  bookingAppointmentCancellation: BookingAppointmentCancellationInput;
};

export type MutationCreateTestDriveBookingArgs = {
  testDriveBookingAppointmentAttempt: TestDriveBookingAppointmentAttemptInput;
};

export type OneDoc = {
  active: Scalars['Boolean'];
  orgID: Maybe<Scalars['String']>;
};

export type OnlineCode = {
  baumusterMatchPoints: Maybe<Scalars['Int']>;
  bodyStyleMatchPoints: Maybe<Scalars['Int']>;
  classMatchPoints: Maybe<Scalars['Int']>;
  frontend: Maybe<Scalars['Object']>;
  modelYearMatchPoints: Maybe<Scalars['Int']>;
  visible: Maybe<Scalars['Boolean']>;
};

export type OnlineCodeMatch = {
  model: Maybe<Model>;
  motorisation: Maybe<Motorisation>;
};

export type PickMeUpFromHome = {
  active: Scalars['Boolean'];
  radius: Maybe<Scalars['String']>;
};

export type PricingDetails = {
  currencyCode: Maybe<Scalars['String']>;
  deductibleAmount: Maybe<Scalars['Float']>;
  includedMileage: Maybe<Scalars['Int']>;
  numberOfDays: Maybe<Scalars['Int']>;
  pricePerKm: Maybe<Scalars['Float']>;
  pricingCategoryName: Maybe<Scalars['String']>;
  totalGrossPrice: Maybe<Scalars['Float']>;
  totalNetPrice: Maybe<Scalars['Float']>;
  totalVatAmount: Maybe<Scalars['Float']>;
  unlimitedMileage: Maybe<Scalars['Boolean']>;
};

export type PricingDetailsInput = {
  numberOfDays: Maybe<Scalars['Int']>;
  totalGrossPrice: Maybe<Scalars['Float']>;
  includedMileage: Maybe<Scalars['Int']>;
  pricePerKm: Maybe<Scalars['Float']>;
  pricingCategoryName: Maybe<Scalars['String']>;
  unlimitedMileage: Maybe<Scalars['Boolean']>;
  totalNetPrice: Maybe<Scalars['Float']>;
  currencyCode: Maybe<Scalars['String']>;
  deductibleAmount: Maybe<Scalars['Float']>;
  totalVatAmount: Maybe<Scalars['Float']>;
};

export type PrivacyOptionInput = {
  id: Maybe<Scalars['String']>;
  consented: Maybe<Scalars['Boolean']>;
};

export enum ProfileType {
  BUSINESS = 'BUSINESS',
  CONSUMER = 'CONSUMER',
}

export type Query = {
  rentPrices: Maybe<PricingDetails>;
  rentalBookings: Maybe<AppointmentStatusWrapper_BookingStatus>;
  testDriveRequestsCalendar: Maybe<
    Array<Maybe<TestDriveRequestDayAvailability>>
  >;
  models: Maybe<Array<Maybe<Model>>>;
  rentModels: Maybe<Array<Maybe<Model>>>;
  bookingTimeSlots: Maybe<Array<Maybe<TimeSlot>>>;
  rentVehicleCalendar: Maybe<Array<Maybe<RentalDayAvailability>>>;
  configurations: Maybe<UiConfiguration>;
  dealers: Maybe<Dealer>;
  testDriveBookingsTimeslots: Maybe<BookingDurationTimeSlots>;
  onlineCodes: Maybe<OnlineCodeMatch>;
  users: Maybe<CiasClaim>;
  usersEmail: Maybe<CiasClaimByEmail>;
  dealerSearch: Maybe<DealerSearchMatch>;
  userTestDriveRequests: Maybe<Array<Maybe<TestDriveRequestConfirmation>>>;
  testDriveBookingSimilarVehiclesSearch: Maybe<Array<Maybe<TestDriveVehicle>>>;
  userTestDriveBookings: Maybe<Array<Maybe<BookingAppointmentConfirmation>>>;
  testDriveBookings: Maybe<BookingAppointmentConfirmation>;
  motorisations: Maybe<Motorisation>;
  days: Maybe<Array<Maybe<TestDriveDayAvailability>>>;
  specificModel: Maybe<Model>;
  testDriveBookingVehicleSearch: Maybe<Array<Maybe<TestDriveVehicle>>>;
  testDriveBookingVehicleSearchWithinRadius: Maybe<TestDriveBookingVehicleDealer>;
  testDriveBookingVehicleSearchFixedDealer: Maybe<TestDriveBookingVehicleDealer>;
  testDriveBookingsCalendar: Maybe<
    Array<Maybe<TestDriveBookingDayAvailability>>
  >;
  suggestions: Maybe<Array<Maybe<LocationSuggestion>>>;
  suggestionsPostalCode: Maybe<Array<Maybe<LocationSuggestion>>>;
  rentVehicleSearch: Maybe<TestDriveBookingVehicleDealer>;
  testDriveDealers: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type QueryRentPricesArgs = {
  startDateTime: Scalars['String'];
  dealerId: Scalars['String'];
  countryCode: Scalars['String'];
  vin: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  endDateTime: Scalars['String'];
};

export type QueryRentalBookingsArgs = {
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  id: Scalars['String'];
};

export type QueryTestDriveRequestsCalendarArgs = {
  endDate: Scalars['LocalDate'];
  dealerId: Scalars['String'];
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  startDate: Scalars['LocalDate'];
};

export type QueryModelsArgs = {
  filter: ModelFilterInput;
  filterMotorisations?: Maybe<Scalars['Boolean']>;
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  category?: Maybe<Category>;
};

export type QueryRentModelsArgs = {
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  category: Maybe<Category>;
};

export type QueryBookingTimeSlotsArgs = {
  dealerId: Scalars['String'];
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  vehicleId: Scalars['String'];
  day: Scalars['LocalDate'];
};

export type QueryRentVehicleCalendarArgs = {
  endDate: Scalars['LocalDate'];
  dealerId: Scalars['String'];
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  vin: Scalars['String'];
  language: Scalars['String'];
  startDate: Scalars['LocalDate'];
};

export type QueryConfigurationsArgs = {
  domain?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  language: Scalars['String'];
};

export type QueryDealersArgs = {
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  id: Scalars['String'];
};

export type QueryTestDriveBookingsTimeslotsArgs = {
  dealerId: Scalars['String'];
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  vehicleId: Scalars['String'];
  day: Scalars['LocalDate'];
};

export type QueryOnlineCodesArgs = {
  onlineCode: Scalars['String'];
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
};

export type QueryUsersArgs = {
  token: Scalars['String'];
};

export type QueryUsersEmailArgs = {
  email: Scalars['String'];
};

export type QueryDealerSearchArgs = {
  locationId: Scalars['String'];
  countryCode: Scalars['String'];
  language: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  searchProfileName: Maybe<Scalars['String']>;
  radius?: Maybe<Scalars['String']>;
  pickMeUp?: Maybe<Scalars['Boolean']>;
};

export type QueryUserTestDriveRequestsArgs = {
  startDateTime: Maybe<Scalars['String']>;
  vehicleTypes: Maybe<Scalars['Set']>;
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  modelSeriesId: Maybe<Scalars['String']>;
};

export type QueryTestDriveBookingSimilarVehiclesSearchArgs = {
  vehicleTypes: Maybe<Scalars['Set']>;
  dealersId: Scalars['Set'];
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  modelSeriesId: Scalars['String'];
};

export type QueryUserTestDriveBookingsArgs = {
  startDateTime: Maybe<Scalars['String']>;
  vehicleTypes: Maybe<Scalars['Set']>;
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  modelSeriesId: Maybe<Scalars['String']>;
};

export type QueryTestDriveBookingsArgs = {
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  id: Scalars['String'];
};

export type QueryMotorisationsArgs = {
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  id: Scalars['String'];
};

export type QueryDaysArgs = {
  includeBookingOptions?: Maybe<Scalars['Boolean']>;
  wholesale?: Maybe<Scalars['String']>;
  transmission: Maybe<Transmission>;
  fuelType: Maybe<FuelType>;
  endDate: Scalars['LocalDate'];
  dealerId: Scalars['String'];
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  modelSeriesId: Scalars['String'];
  startDate: Scalars['LocalDate'];
};

export type QuerySpecificModelArgs = {
  vehicleTypes: Maybe<Scalars['Set']>;
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  modelSeriesId: Scalars['String'];
  archivedMotorisations?: Maybe<Scalars['Boolean']>;
};

export type QueryTestDriveBookingVehicleSearchArgs = {
  endDate: Scalars['LocalDate'];
  vehicleTypes: Maybe<Scalars['Set']>;
  dealersId: Scalars['Set'];
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  startDate: Scalars['LocalDate'];
  modelSeriesId: Scalars['String'];
};

export type QueryTestDriveBookingVehicleSearchWithinRadiusArgs = {
  startDate: Maybe<Scalars['LocalDate']>;
  endDate: Maybe<Scalars['LocalDate']>;
  date: Maybe<Scalars['LocalDate']>;
  vehicleTypes: Maybe<Scalars['Set']>;
  countryCode: Scalars['String'];
  market: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  modelSeriesId: Scalars['String'];
  locationId: Maybe<Scalars['String']>;
  locationQuery: Maybe<Scalars['String']>;
  radius?: Maybe<Scalars['String']>;
  searchProfileName: Maybe<Scalars['String']>;
  pickMeUp?: Maybe<Scalars['Boolean']>;
};

export type QueryTestDriveBookingVehicleSearchFixedDealerArgs = {
  startDate: Maybe<Scalars['LocalDate']>;
  endDate: Maybe<Scalars['LocalDate']>;
  date: Maybe<Scalars['LocalDate']>;
  vehicleTypes: Maybe<Scalars['Set']>;
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  modelSeriesId: Scalars['String'];
  dealerId: Scalars['String'];
  searchProfileName: Maybe<Scalars['String']>;
  pickMeUp?: Maybe<Scalars['Boolean']>;
};

export type QueryTestDriveBookingsCalendarArgs = {
  endDate: Scalars['LocalDate'];
  dealerId: Scalars['String'];
  countryCode: Scalars['String'];
  context?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  language: Scalars['String'];
  vehicleId: Scalars['String'];
  startDate: Scalars['LocalDate'];
};

export type QuerySuggestionsArgs = {
  countryCode: Scalars['String'];
  market: Maybe<Scalars['String']>;
  address: Scalars['String'];
};

export type QuerySuggestionsPostalCodeArgs = {
  countryCode: Scalars['String'];
  postalCode: Scalars['String'];
};

export type QueryRentVehicleSearchArgs = {
  domain?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['String']>;
  countryCode: Scalars['String'];
  language: Scalars['String'];
  startDateTime: Scalars['String'];
  endDateTime: Scalars['String'];
  vehicleTypes: Maybe<Scalars['Set']>;
  locationId: Scalars['String'];
  radius?: Maybe<Scalars['String']>;
  searchProfileName: Scalars['String'];
  pickMeUp?: Maybe<Scalars['Boolean']>;
};

export type QueryTestDriveDealersArgs = {
  vehicleTypes: Maybe<Scalars['Set']>;
  countryCode: Scalars['String'];
  language: Scalars['String'];
  modelSeriesId: Scalars['String'];
};

export type RentalBookingAppointmentAttemptInput = {
  pricingDetails: Maybe<PricingDetailsInput>;
  countryCode: Maybe<Scalars['String']>;
  appointmentPreferences: Maybe<BookingAttemptPreferencesInput>;
  sourceSystem: Maybe<Scalars['String']>;
  context: Maybe<Scalars['String']>;
  domain: Maybe<Scalars['String']>;
  language: Maybe<Scalars['String']>;
  trackingParameter: Maybe<Scalars['String']>;
  customer: Maybe<CustomizableBookingCustomerInput>;
  campaignId: Maybe<Scalars['String']>;
  appointmentMessage: Maybe<Scalars['String']>;
  dealerId: Maybe<Scalars['String']>;
};

export type RentalDayAvailability = {
  available: Scalars['Boolean'];
  businessHoursPeriods: Maybe<Array<Maybe<BusinessHoursPeriod>>>;
  date: Maybe<Scalars['LocalDate']>;
  dealerOpen: Scalars['Boolean'];
  zoneOffSet: Maybe<Scalars['String']>;
};

export type RequestAttemptPreferencesInput = {
  driveType: Maybe<DriveType>;
  motorisationId: Maybe<Scalars['String']>;
  fuelType: Maybe<FuelType>;
  weightCategory: Maybe<WeightCategory>;
  modelSeriesId: Maybe<Scalars['String']>;
  engine: Maybe<EngineInput>;
  schedule: Maybe<RequestSchedulePreferenceInput>;
  wheelBase: Maybe<WheelBaseInput>;
  pickMeUp: Maybe<Scalars['Boolean']>;
  vehicleTypes: Maybe<Scalars['Set']>;
  transmission: Maybe<Transmission>;
  onlineCode: Maybe<Scalars['String']>;
};

export type RequestSchedulePreference = {
  dayPeriod: Maybe<Scalars['String']>;
  pickUpDateStr: Maybe<Scalars['String']>;
  pickUpDateTime: Maybe<Scalars['OffsetDateTime']>;
  returnDateStr: Maybe<Scalars['String']>;
  returnDateTime: Maybe<Scalars['OffsetDateTime']>;
};

export type RequestSchedulePreferenceInput = {
  returnDateTime: Maybe<Scalars['OffsetDateTime']>;
  returnDateStr: Maybe<Scalars['String']>;
  pickUpDateStr: Maybe<Scalars['String']>;
  pickUpDateTime: Maybe<Scalars['OffsetDateTime']>;
  dayPeriod: Maybe<Scalars['String']>;
};

export enum RequestStatus {
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING',
  PROCESSED = 'PROCESSED',
  REQUESTED = 'REQUESTED',
}

export type RequestTimeSlot = {
  available: Scalars['Boolean'];
  end: Maybe<Scalars['OffsetDateTime']>;
  periodId: Maybe<Scalars['String']>;
  start: Maybe<Scalars['OffsetDateTime']>;
};

export enum Salutation {
  DIVERSE = 'DIVERSE',
  MISS = 'MISS',
  MR = 'MR',
  MRS = 'MRS',
  MS = 'MS',
}

export type SchedulePreference = {
  pickUpDateStr: Maybe<Scalars['String']>;
  pickUpDateTime: Maybe<Scalars['OffsetDateTime']>;
  returnDateStr: Maybe<Scalars['String']>;
  returnDateTime: Maybe<Scalars['OffsetDateTime']>;
};

export type SchedulePreferenceInput = {
  returnDateStr: Maybe<Scalars['String']>;
  pickUpDateStr: Maybe<Scalars['String']>;
  pickUpDateTime: Maybe<Scalars['OffsetDateTime']>;
  returnDateTime: Maybe<Scalars['OffsetDateTime']>;
};

export type SharedNotifications = {
  driverLicenseNotifications: Maybe<DriverLicenseNotifications>;
  minimumDriverAgeNotifications: Maybe<MinimumDriverAgeNotifications>;
};

export type SimilarVehicles = {
  active: Scalars['Boolean'];
  similarVehiclesCriteria: Maybe<Scalars['String']>;
  similarVehiclesSuggestions: Maybe<Scalars['Object']>;
};

export type SummaryConfiguration = {
  frontend: Maybe<Scalars['Object']>;
};

export type TechnicalMetric = {
  unit: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type TechnicalMetricInput = {
  unit: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export type TechnicalRangeMetric = {
  individual: Maybe<Scalars['String']>;
  max: Maybe<Scalars['String']>;
  min: Maybe<Scalars['String']>;
  unit: Maybe<Scalars['String']>;
};

export type TestDriveBookingAppointmentAttemptInput = {
  sourceSystem: Maybe<Scalars['String']>;
  trackingParameter: Maybe<Scalars['String']>;
  appointmentMessage: Maybe<Scalars['String']>;
  countryCode: Maybe<Scalars['String']>;
  language: Maybe<Scalars['String']>;
  context: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  dealerId: Maybe<Scalars['String']>;
  customer: Maybe<CustomizableBookingCustomerInput>;
  campaignId: Maybe<Scalars['String']>;
  appointmentPreferences: Maybe<BookingAttemptPreferencesInput>;
};

export type TestDriveBookingDayAvailability = {
  available: Scalars['Boolean'];
  date: Maybe<Scalars['LocalDate']>;
  dealerOpen: Scalars['Boolean'];
};

export type TestDriveBookingRescheduleInput = {
  dealerId: Maybe<Scalars['String']>;
  sourceSystem: Maybe<Scalars['String']>;
  countryCode: Maybe<Scalars['String']>;
  language: Maybe<Scalars['String']>;
  appointmentPreferences: Maybe<BookingAttemptPreferencesInput>;
  trackingParameter: Maybe<Scalars['String']>;
  context: Maybe<Scalars['String']>;
  domain: Maybe<Scalars['String']>;
  campaignId: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
  appointmentMessage: Maybe<Scalars['String']>;
};

export type TestDriveBookingVehicleDealer = {
  bookings: Maybe<Array<Maybe<TestDriveVehicle>>>;
  dealers: Maybe<Array<Maybe<Dealer>>>;
};

export type TestDriveDayAvailability = {
  available: Scalars['Boolean'];
  bookingOptions: Maybe<Array<Maybe<BookingOption>>>;
  date: Maybe<Scalars['LocalDate']>;
  requestTimeSlots: Maybe<Array<Maybe<TimeSlot>>>;
};

export type TestDriveRequestAttemptInput = {
  dealerId: Maybe<Scalars['String']>;
  appointmentPreferences: Maybe<RequestAttemptPreferencesInput>;
  customer: Maybe<CustomizableRequestCustomerInput>;
  countryCode: Maybe<Scalars['String']>;
  campaignId: Maybe<Scalars['String']>;
  context: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  appointmentMessage: Maybe<Scalars['String']>;
  language: Maybe<Scalars['String']>;
  trackingParameter: Maybe<Scalars['String']>;
  sourceSystem: Maybe<Scalars['String']>;
};

export type TestDriveRequestConfirmation = {
  appointmentMessage: Maybe<Scalars['String']>;
  countryCode: Maybe<Scalars['String']>;
  dealer: Maybe<Dealer>;
  fuelType: Maybe<FuelType>;
  id: Maybe<Scalars['String']>;
  language: Maybe<Scalars['String']>;
  model: Maybe<Model>;
  motorisation: Maybe<Motorisation>;
  schedule: Maybe<RequestSchedulePreference>;
  status: Maybe<RequestStatus>;
  transmission: Maybe<Transmission>;
};

export type TestDriveRequestDayAvailability = {
  available: Scalars['Boolean'];
  date: Maybe<Scalars['LocalDate']>;
  dealerOpen: Scalars['Boolean'];
  requestTimeSlots: Maybe<Array<Maybe<RequestTimeSlot>>>;
};

export type TestDriveVehicle = {
  baumuster: Maybe<Scalars['String']>;
  booking: Scalars['Boolean'];
  co2Emission: Maybe<TechnicalRangeMetric>;
  dealerId: Maybe<Scalars['String']>;
  energyEfficiencyClass: Maybe<ValuedEnumWrapper_EnergyEfficiencyClass>;
  engine: Maybe<Engine>;
  fuelConsumption: Maybe<FuelConsumptionMetrics>;
  timePeriodAvailability: Maybe<TimePeriodAvailability>;
  fuelType: Maybe<FuelType>;
  id: Maybe<Scalars['String']>;
  images: Maybe<Images>;
  minimumDriverAge: Maybe<Scalars['String']>;
  modelName: Maybe<Scalars['String']>;
  modelSeriesId: Maybe<Scalars['String']>;
  motorisationId: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
  registration: Maybe<Scalars['String']>;
  registrationDate: Maybe<Scalars['String']>;
  requiredDrivingLicenceCategory: Maybe<Scalars['String']>;
  transmission: Maybe<Transmission>;
  vehicleTypes: Maybe<Array<Maybe<VehicleType>>>;
  vin: Maybe<Scalars['String']>;
  weightCategory: Maybe<WeightCategory>;
  classId: Maybe<Scalars['String']>;
  bodyStyleId: Maybe<Scalars['String']>;
  pricingDetails: Maybe<PricingDetails>;
  numberOfSeats: Maybe<Scalars['Int']>;
  navigationSystem: Maybe<Scalars['Boolean']>;
  trailerhitch: Maybe<Scalars['Boolean']>;
  heatedseats: Maybe<Scalars['Boolean']>;
  wintertyres: Maybe<Scalars['Boolean']>;
  parkingcamera: Maybe<Scalars['Boolean']>;
  allWheelDrive: Maybe<Scalars['Boolean']>;
  airCondition: Maybe<Scalars['Boolean']>;
  mbux: Maybe<Scalars['Boolean']>;
  sunRoof: Maybe<Scalars['Boolean']>;
  cruiseControl: Maybe<Scalars['Boolean']>;
  luggage: Maybe<Scalars['Int']>;
};

export type TimePeriodAvailability = {
  morning: Maybe<Scalars['Boolean']>;
  afternoon: Maybe<Scalars['Boolean']>;
  evening: Maybe<Scalars['Boolean']>;
};

export type TimePicker = {
  bookingTimeslotInterval: Scalars['Int'];
  dayTimePeriods: Maybe<Array<Maybe<DayTimePeriod>>>;
  schedule: Maybe<Scalars['Object']>;
  timeSlotDuration: Scalars['Int'];
};

export type TimeSlot = {
  available: Scalars['Boolean'];
  end: Maybe<Scalars['OffsetDateTime']>;
  start: Maybe<Scalars['OffsetDateTime']>;
};

export type TimeSlotInterval = {
  end: Maybe<Scalars['OffsetDateTime']>;
  start: Maybe<Scalars['OffsetDateTime']>;
};

export enum Title {
  DR = 'DR',
  MISS = 'MISS',
  MR = 'MR',
  MRS = 'MRS',
  MS = 'MS',
  PROF = 'PROF',
  PROF_DR = 'PROF_DR',
  REVEREND = 'REVEREND',
  SIR = 'SIR',
}

export type TrackingInfo = {
  sendTrackingInfo: Scalars['Boolean'];
  trackingParameterKeyValueSplitter: Maybe<Scalars['String']>;
  trackingParameterSplitter: Maybe<Scalars['String']>;
};

export enum Transmission {
  AUTOMATIC = 'AUTOMATIC',
  MANUAL = 'MANUAL',
}

export type UiBooking = {
  bookingActive: Scalars['Boolean'];
  dmoBooking: Maybe<DmoBooking>;
  forceBookingOnly: Scalars['Boolean'];
  rescheduleActive: Scalars['Boolean'];
  similarVehicles: Maybe<SimilarVehicles>;
  trackingInfo: Maybe<TrackingInfo>;
};

export type UiConfiguration = {
  aemFormsHandlerConfig: Maybe<AemFormsHandlerConfig>;
  aemFormsResources: Maybe<AemFormsResourcesConfiguration>;
  booking: Maybe<UiBooking>;
  calendar: Maybe<AppointmentCalendar>;
  cancellationForm: Maybe<FormConfiguration>;
  contactForm: Maybe<FormConfiguration>;
  countryHub: Maybe<Array<Maybe<Scalars['String']>>>;
  dealerSearch: Maybe<DealerSearch>;
  footNotes: Maybe<FootNotesConfiguration>;
  infoBanner: Maybe<InfoBannerConfiguration>;
  labels: Maybe<Scalars['Object']>;
  links: Maybe<Scalars['Object']>;
  maintenance: Maybe<Maintenance>;
  modelSelection: Maybe<ModelSelection>;
  modelSeriesMapper: Maybe<ModelSeriesMapper>;
  oneDoc: Maybe<OneDoc>;
  pickMeUpFromHome: Maybe<PickMeUpFromHome>;
  scheduleForm: Maybe<FormConfiguration>;
  sharedNotifications: Maybe<SharedNotifications>;
  summary: Maybe<SummaryConfiguration>;
};

export type ValuedEnumWrapper_EnergyEfficiencyClass = {
  name: Maybe<Scalars['String']>;
  value: Maybe<Scalars['String']>;
};

export enum VehicleType {
  ALL_TERRAIN = 'ALL_TERRAIN',
  MERCEDES_AMG = 'MERCEDES_AMG',
  MERCEDES_EQ = 'MERCEDES_EQ',
  MERCEDES_MAYBACH = 'MERCEDES_MAYBACH',
  SMART = 'SMART',
}

export type Weight = {
  maximum: Maybe<Scalars['Object']>;
  unloaded: Maybe<Scalars['Object']>;
};

export enum WeightCategory {
  HEAVY_WEIGHT = 'HEAVY_WEIGHT',
  LIGHT_WEIGHT = 'LIGHT_WEIGHT',
}

export type WheelBase = {
  id: Maybe<Scalars['String']>;
  name: Maybe<Scalars['String']>;
};

export type WheelBaseInput = {
  name: Maybe<Scalars['String']>;
  id: Maybe<Scalars['String']>;
};

export type WhiteList = {
  active: Maybe<Scalars['Boolean']>;
  frontend: Maybe<Scalars['Object']>;
};

export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;

export type LegacyStitchingResolver<TResult, TParent, TContext, TArgs> = {
  fragment: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};

export type NewStitchingResolver<TResult, TParent, TContext, TArgs> = {
  selectionSet: string;
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type StitchingResolver<TResult, TParent, TContext, TArgs> =
  | LegacyStitchingResolver<TResult, TParent, TContext, TArgs>
  | NewStitchingResolver<TResult, TParent, TContext, TArgs>;
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> =
  | ResolverFn<TResult, TParent, TContext, TArgs>
  | StitchingResolver<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterator<TResult> | Promise<AsyncIterator<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs
> {
  subscribe: SubscriptionSubscribeFn<
    { [key in TKey]: TResult },
    TParent,
    TContext,
    TArgs
  >;
  resolve?: SubscriptionResolveFn<
    TResult,
    { [key in TKey]: TResult },
    TContext,
    TArgs
  >;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<
  TResult,
  TKey extends string,
  TParent,
  TContext,
  TArgs
> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<
  TResult,
  TKey extends string,
  TParent = {},
  TContext = {},
  TArgs = {}
> =
  | ((
      ...args: any[]
    ) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (
  obj: T,
  context: TContext,
  info: GraphQLResolveInfo
) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<
  TResult = {},
  TParent = {},
  TContext = {},
  TArgs = {}
> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  Query: ResolverTypeWrapper<{}>;
  String: ResolverTypeWrapper<Scalars['String']>;
  PricingDetails: ResolverTypeWrapper<PricingDetails>;
  Float: ResolverTypeWrapper<Scalars['Float']>;
  Int: ResolverTypeWrapper<Scalars['Int']>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']>;
  AppointmentStatusWrapper_BookingStatus: ResolverTypeWrapper<AppointmentStatusWrapper_BookingStatus>;
  LocalDate: ResolverTypeWrapper<Scalars['LocalDate']>;
  TestDriveRequestDayAvailability: ResolverTypeWrapper<TestDriveRequestDayAvailability>;
  RequestTimeSlot: ResolverTypeWrapper<RequestTimeSlot>;
  OffsetDateTime: ResolverTypeWrapper<Scalars['OffsetDateTime']>;
  ModelFilterInput: ModelFilterInput;
  Category: Category;
  Model: ResolverTypeWrapper<Model>;
  FuelType: FuelType;
  Group: Group;
  Images: ResolverTypeWrapper<Images>;
  Object: ResolverTypeWrapper<Scalars['Object']>;
  Motorisation: ResolverTypeWrapper<Motorisation>;
  TechnicalRangeMetric: ResolverTypeWrapper<TechnicalRangeMetric>;
  DriveType: DriveType;
  Engine: ResolverTypeWrapper<Engine>;
  TechnicalMetric: ResolverTypeWrapper<TechnicalMetric>;
  EngineType: EngineType;
  FuelConsumptionMetrics: ResolverTypeWrapper<FuelConsumptionMetrics>;
  LifeCycle: LifeCycle;
  Transmission: Transmission;
  VehicleType: VehicleType;
  Weight: ResolverTypeWrapper<Weight>;
  WeightCategory: WeightCategory;
  WheelBase: ResolverTypeWrapper<WheelBase>;
  TimeSlot: ResolverTypeWrapper<TimeSlot>;
  RentalDayAvailability: ResolverTypeWrapper<RentalDayAvailability>;
  BusinessHoursPeriod: ResolverTypeWrapper<BusinessHoursPeriod>;
  LocalTime: ResolverTypeWrapper<Scalars['LocalTime']>;
  UiConfiguration: ResolverTypeWrapper<UiConfiguration>;
  AemFormsHandlerConfig: ResolverTypeWrapper<AemFormsHandlerConfig>;
  AemFormsResourcesConfiguration: ResolverTypeWrapper<AemFormsResourcesConfiguration>;
  UiBooking: ResolverTypeWrapper<UiBooking>;
  DMOBooking: ResolverTypeWrapper<DmoBooking>;
  WhiteList: ResolverTypeWrapper<WhiteList>;
  SimilarVehicles: ResolverTypeWrapper<SimilarVehicles>;
  TrackingInfo: ResolverTypeWrapper<TrackingInfo>;
  AppointmentCalendar: ResolverTypeWrapper<AppointmentCalendar>;
  ClosingDatePeriod: ResolverTypeWrapper<ClosingDatePeriod>;
  TimePicker: ResolverTypeWrapper<TimePicker>;
  DayTimePeriod: ResolverTypeWrapper<DayTimePeriod>;
  FormConfiguration: ResolverTypeWrapper<FormConfiguration>;
  DealerSearch: ResolverTypeWrapper<DealerSearch>;
  FootNotesConfiguration: ResolverTypeWrapper<FootNotesConfiguration>;
  InfoBannerConfiguration: ResolverTypeWrapper<InfoBannerConfiguration>;
  Maintenance: ResolverTypeWrapper<Maintenance>;
  ModelSelection: ResolverTypeWrapper<ModelSelection>;
  CarbonFootprint: ResolverTypeWrapper<CarbonFootprint>;
  Co2EmissionAndFuelConsumption: ResolverTypeWrapper<Co2EmissionAndFuelConsumption>;
  EnergyEfficiency: ResolverTypeWrapper<EnergyEfficiency>;
  OnlineCode: ResolverTypeWrapper<OnlineCode>;
  ModelSeriesMapper: ResolverTypeWrapper<ModelSeriesMapper>;
  OneDoc: ResolverTypeWrapper<OneDoc>;
  PickMeUpFromHome: ResolverTypeWrapper<PickMeUpFromHome>;
  SharedNotifications: ResolverTypeWrapper<SharedNotifications>;
  DriverLicenseNotifications: ResolverTypeWrapper<DriverLicenseNotifications>;
  MinimumDriverAgeNotifications: ResolverTypeWrapper<MinimumDriverAgeNotifications>;
  SummaryConfiguration: ResolverTypeWrapper<SummaryConfiguration>;
  Dealer: ResolverTypeWrapper<Dealer>;
  DealerAddress: ResolverTypeWrapper<DealerAddress>;
  Coordinates: ResolverTypeWrapper<Coordinates>;
  DealerContacts: ResolverTypeWrapper<DealerContacts>;
  BookingDurationTimeSlots: ResolverTypeWrapper<BookingDurationTimeSlots>;
  BookingDuration: ResolverTypeWrapper<BookingDuration>;
  TimeSlotInterval: ResolverTypeWrapper<TimeSlotInterval>;
  OnlineCodeMatch: ResolverTypeWrapper<OnlineCodeMatch>;
  CiasClaim: ResolverTypeWrapper<CiasClaim>;
  CiasClaimByEmail: ResolverTypeWrapper<CiasClaimByEmail>;
  DealerSearchMatch: ResolverTypeWrapper<DealerSearchMatch>;
  Set: ResolverTypeWrapper<Scalars['Set']>;
  TestDriveRequestConfirmation: ResolverTypeWrapper<TestDriveRequestConfirmation>;
  RequestSchedulePreference: ResolverTypeWrapper<RequestSchedulePreference>;
  RequestStatus: RequestStatus;
  TestDriveVehicle: ResolverTypeWrapper<TestDriveVehicle>;
  ValuedEnumWrapper_EnergyEfficiencyClass: ResolverTypeWrapper<ValuedEnumWrapper_EnergyEfficiencyClass>;
  TimePeriodAvailability: ResolverTypeWrapper<TimePeriodAvailability>;
  BookingAppointmentConfirmation: ResolverTypeWrapper<BookingAppointmentConfirmation>;
  AppointmentType: AppointmentType;
  SchedulePreference: ResolverTypeWrapper<SchedulePreference>;
  BookingStatus: BookingStatus;
  TestDriveDayAvailability: ResolverTypeWrapper<TestDriveDayAvailability>;
  BookingOption: ResolverTypeWrapper<BookingOption>;
  DayAvailability: ResolverTypeWrapper<DayAvailability>;
  TestDriveBookingVehicleDealer: ResolverTypeWrapper<TestDriveBookingVehicleDealer>;
  TestDriveBookingDayAvailability: ResolverTypeWrapper<TestDriveBookingDayAvailability>;
  LocationSuggestion: ResolverTypeWrapper<LocationSuggestion>;
  Mutation: ResolverTypeWrapper<{}>;
  RentalBookingAppointmentAttemptInput: RentalBookingAppointmentAttemptInput;
  PricingDetailsInput: PricingDetailsInput;
  BookingAttemptPreferencesInput: BookingAttemptPreferencesInput;
  EngineInput: EngineInput;
  TechnicalMetricInput: TechnicalMetricInput;
  WheelBaseInput: WheelBaseInput;
  SchedulePreferenceInput: SchedulePreferenceInput;
  CustomizableBookingCustomerInput: CustomizableBookingCustomerInput;
  Salutation: Salutation;
  Title: Title;
  CustomerAddressInput: CustomerAddressInput;
  DeclarationOfConsentInput: DeclarationOfConsentInput;
  PrivacyOptionsSet: ResolverTypeWrapper<Scalars['PrivacyOptionsSet']>;
  CustomerContactsInput: CustomerContactsInput;
  ProfileType: ProfileType;
  TestDriveBookingRescheduleInput: TestDriveBookingRescheduleInput;
  TestDriveRequestAttemptInput: TestDriveRequestAttemptInput;
  RequestAttemptPreferencesInput: RequestAttemptPreferencesInput;
  RequestSchedulePreferenceInput: RequestSchedulePreferenceInput;
  CustomizableRequestCustomerInput: CustomizableRequestCustomerInput;
  AppointmentStatusWrapper_RequestStatus: ResolverTypeWrapper<AppointmentStatusWrapper_RequestStatus>;
  BookingAppointmentCancellationInput: BookingAppointmentCancellationInput;
  BookingAppointmentCancellation: ResolverTypeWrapper<BookingAppointmentCancellation>;
  TestDriveBookingAppointmentAttemptInput: TestDriveBookingAppointmentAttemptInput;
  CommunicationOption: CommunicationOption;
  PrivacyOptionInput: PrivacyOptionInput;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  Query: {};
  String: Scalars['String'];
  PricingDetails: PricingDetails;
  Float: Scalars['Float'];
  Int: Scalars['Int'];
  Boolean: Scalars['Boolean'];
  AppointmentStatusWrapper_BookingStatus: AppointmentStatusWrapper_BookingStatus;
  LocalDate: Scalars['LocalDate'];
  TestDriveRequestDayAvailability: TestDriveRequestDayAvailability;
  RequestTimeSlot: RequestTimeSlot;
  OffsetDateTime: Scalars['OffsetDateTime'];
  ModelFilterInput: ModelFilterInput;
  Model: Model;
  Images: Images;
  Object: Scalars['Object'];
  Motorisation: Motorisation;
  TechnicalRangeMetric: TechnicalRangeMetric;
  Engine: Engine;
  TechnicalMetric: TechnicalMetric;
  FuelConsumptionMetrics: FuelConsumptionMetrics;
  Weight: Weight;
  WheelBase: WheelBase;
  TimeSlot: TimeSlot;
  RentalDayAvailability: RentalDayAvailability;
  BusinessHoursPeriod: BusinessHoursPeriod;
  LocalTime: Scalars['LocalTime'];
  UiConfiguration: UiConfiguration;
  AemFormsHandlerConfig: AemFormsHandlerConfig;
  AemFormsResourcesConfiguration: AemFormsResourcesConfiguration;
  UiBooking: UiBooking;
  DMOBooking: DmoBooking;
  WhiteList: WhiteList;
  SimilarVehicles: SimilarVehicles;
  TrackingInfo: TrackingInfo;
  AppointmentCalendar: AppointmentCalendar;
  ClosingDatePeriod: ClosingDatePeriod;
  TimePicker: TimePicker;
  DayTimePeriod: DayTimePeriod;
  FormConfiguration: FormConfiguration;
  DealerSearch: DealerSearch;
  FootNotesConfiguration: FootNotesConfiguration;
  InfoBannerConfiguration: InfoBannerConfiguration;
  Maintenance: Maintenance;
  ModelSelection: ModelSelection;
  CarbonFootprint: CarbonFootprint;
  Co2EmissionAndFuelConsumption: Co2EmissionAndFuelConsumption;
  EnergyEfficiency: EnergyEfficiency;
  OnlineCode: OnlineCode;
  ModelSeriesMapper: ModelSeriesMapper;
  OneDoc: OneDoc;
  PickMeUpFromHome: PickMeUpFromHome;
  SharedNotifications: SharedNotifications;
  DriverLicenseNotifications: DriverLicenseNotifications;
  MinimumDriverAgeNotifications: MinimumDriverAgeNotifications;
  SummaryConfiguration: SummaryConfiguration;
  Dealer: Dealer;
  DealerAddress: DealerAddress;
  Coordinates: Coordinates;
  DealerContacts: DealerContacts;
  BookingDurationTimeSlots: BookingDurationTimeSlots;
  BookingDuration: BookingDuration;
  TimeSlotInterval: TimeSlotInterval;
  OnlineCodeMatch: OnlineCodeMatch;
  CiasClaim: CiasClaim;
  CiasClaimByEmail: CiasClaimByEmail;
  DealerSearchMatch: DealerSearchMatch;
  Set: Scalars['Set'];
  TestDriveRequestConfirmation: TestDriveRequestConfirmation;
  RequestSchedulePreference: RequestSchedulePreference;
  TestDriveVehicle: TestDriveVehicle;
  ValuedEnumWrapper_EnergyEfficiencyClass: ValuedEnumWrapper_EnergyEfficiencyClass;
  TimePeriodAvailability: TimePeriodAvailability;
  BookingAppointmentConfirmation: BookingAppointmentConfirmation;
  SchedulePreference: SchedulePreference;
  TestDriveDayAvailability: TestDriveDayAvailability;
  BookingOption: BookingOption;
  DayAvailability: DayAvailability;
  TestDriveBookingVehicleDealer: TestDriveBookingVehicleDealer;
  TestDriveBookingDayAvailability: TestDriveBookingDayAvailability;
  LocationSuggestion: LocationSuggestion;
  Mutation: {};
  RentalBookingAppointmentAttemptInput: RentalBookingAppointmentAttemptInput;
  PricingDetailsInput: PricingDetailsInput;
  BookingAttemptPreferencesInput: BookingAttemptPreferencesInput;
  EngineInput: EngineInput;
  TechnicalMetricInput: TechnicalMetricInput;
  WheelBaseInput: WheelBaseInput;
  SchedulePreferenceInput: SchedulePreferenceInput;
  CustomizableBookingCustomerInput: CustomizableBookingCustomerInput;
  CustomerAddressInput: CustomerAddressInput;
  DeclarationOfConsentInput: DeclarationOfConsentInput;
  PrivacyOptionsSet: Scalars['PrivacyOptionsSet'];
  CustomerContactsInput: CustomerContactsInput;
  TestDriveBookingRescheduleInput: TestDriveBookingRescheduleInput;
  TestDriveRequestAttemptInput: TestDriveRequestAttemptInput;
  RequestAttemptPreferencesInput: RequestAttemptPreferencesInput;
  RequestSchedulePreferenceInput: RequestSchedulePreferenceInput;
  CustomizableRequestCustomerInput: CustomizableRequestCustomerInput;
  AppointmentStatusWrapper_RequestStatus: AppointmentStatusWrapper_RequestStatus;
  BookingAppointmentCancellationInput: BookingAppointmentCancellationInput;
  BookingAppointmentCancellation: BookingAppointmentCancellation;
  TestDriveBookingAppointmentAttemptInput: TestDriveBookingAppointmentAttemptInput;
  PrivacyOptionInput: PrivacyOptionInput;
}>;

export type DeferDirectiveArgs = {};

export type DeferDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = DeferDirectiveArgs
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type OneOfDirectiveArgs = {};

export type OneOfDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = OneOfDirectiveArgs
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type SpecifiedByDirectiveArgs = { url: Scalars['String'] };

export type SpecifiedByDirectiveResolver<
  Result,
  Parent,
  ContextType = any,
  Args = SpecifiedByDirectiveArgs
> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type AemFormsHandlerConfigResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AemFormsHandlerConfig'] = ResolversParentTypes['AemFormsHandlerConfig']
> = ResolversObject<{
  frontend: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AemFormsResourcesConfigurationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AemFormsResourcesConfiguration'] = ResolversParentTypes['AemFormsResourcesConfiguration']
> = ResolversObject<{
  frontend: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AppointmentCalendarResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AppointmentCalendar'] = ResolversParentTypes['AppointmentCalendar']
> = ResolversObject<{
  closingPeriods: Resolver<
    Maybe<Array<Maybe<ResolversTypes['ClosingDatePeriod']>>>,
    ParentType,
    ContextType
  >;
  initialUnavailableDays: Resolver<
    ResolversTypes['Int'],
    ParentType,
    ContextType
  >;
  daysToAssertTimePeriodAvailability: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  timePicker: Resolver<
    Maybe<ResolversTypes['TimePicker']>,
    ParentType,
    ContextType
  >;
  weekStartsOn: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AppointmentStatusWrapper_BookingStatusResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AppointmentStatusWrapper_BookingStatus'] = ResolversParentTypes['AppointmentStatusWrapper_BookingStatus']
> = ResolversObject<{
  status: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AppointmentStatusWrapper_RequestStatusResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['AppointmentStatusWrapper_RequestStatus'] = ResolversParentTypes['AppointmentStatusWrapper_RequestStatus']
> = ResolversObject<{
  status: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BookingAppointmentCancellationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BookingAppointmentCancellation'] = ResolversParentTypes['BookingAppointmentCancellation']
> = ResolversObject<{
  cancellationMessage: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  context: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  domain: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  countryCode: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  id: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  language: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BookingAppointmentConfirmationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BookingAppointmentConfirmation'] = ResolversParentTypes['BookingAppointmentConfirmation']
> = ResolversObject<{
  appointmentMessage: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  appointmentType: Resolver<
    Maybe<ResolversTypes['AppointmentType']>,
    ParentType,
    ContextType
  >;
  countryCode: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  dealer: Resolver<Maybe<ResolversTypes['Dealer']>, ParentType, ContextType>;
  id: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  language: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  schedule: Resolver<
    Maybe<ResolversTypes['SchedulePreference']>,
    ParentType,
    ContextType
  >;
  status: Resolver<
    Maybe<ResolversTypes['BookingStatus']>,
    ParentType,
    ContextType
  >;
  vehicle: Resolver<
    Maybe<ResolversTypes['TestDriveVehicle']>,
    ParentType,
    ContextType
  >;
  onlineStoreDeeplink: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BookingDurationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BookingDuration'] = ResolversParentTypes['BookingDuration']
> = ResolversObject<{
  hours: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  minutes: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BookingDurationTimeSlotsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BookingDurationTimeSlots'] = ResolversParentTypes['BookingDurationTimeSlots']
> = ResolversObject<{
  duration: Resolver<
    Maybe<ResolversTypes['BookingDuration']>,
    ParentType,
    ContextType
  >;
  timeSlotInterval: Resolver<
    Maybe<Array<Maybe<ResolversTypes['TimeSlotInterval']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BookingOptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BookingOption'] = ResolversParentTypes['BookingOption']
> = ResolversObject<{
  bookingAvailableDays: Resolver<
    Maybe<Array<Maybe<ResolversTypes['DayAvailability']>>>,
    ParentType,
    ContextType
  >;
  bookingTimeSlots: Resolver<
    Maybe<Array<Maybe<ResolversTypes['TimeSlot']>>>,
    ParentType,
    ContextType
  >;
  dealer: Resolver<Maybe<ResolversTypes['Dealer']>, ParentType, ContextType>;
  vehicle: Resolver<
    Maybe<ResolversTypes['TestDriveVehicle']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessHoursPeriodResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['BusinessHoursPeriod'] = ResolversParentTypes['BusinessHoursPeriod']
> = ResolversObject<{
  closingTime: Resolver<
    Maybe<ResolversTypes['LocalTime']>,
    ParentType,
    ContextType
  >;
  openingTime: Resolver<
    Maybe<ResolversTypes['LocalTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CarbonFootprintResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CarbonFootprint'] = ResolversParentTypes['CarbonFootprint']
> = ResolversObject<{
  co2EmissionAndFuelConsumption: Resolver<
    Maybe<ResolversTypes['Co2EmissionAndFuelConsumption']>,
    ParentType,
    ContextType
  >;
  energyEfficiency: Resolver<
    Maybe<ResolversTypes['EnergyEfficiency']>,
    ParentType,
    ContextType
  >;
  frontend: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CiasClaimResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CiasClaim'] = ResolversParentTypes['CiasClaim']
> = ResolversObject<{
  aud: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ciamUid: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  exp: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iat: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  iss: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  jti: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sub: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CiasClaimByEmailResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['CiasClaimByEmail'] = ResolversParentTypes['CiasClaimByEmail']
> = ResolversObject<{
  userId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ClosingDatePeriodResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ClosingDatePeriod'] = ResolversParentTypes['ClosingDatePeriod']
> = ResolversObject<{
  endDate: Resolver<
    Maybe<ResolversTypes['LocalDate']>,
    ParentType,
    ContextType
  >;
  startDate: Resolver<
    Maybe<ResolversTypes['LocalDate']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Co2EmissionAndFuelConsumptionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Co2EmissionAndFuelConsumption'] = ResolversParentTypes['Co2EmissionAndFuelConsumption']
> = ResolversObject<{
  metricType: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  visible: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CoordinatesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Coordinates'] = ResolversParentTypes['Coordinates']
> = ResolversObject<{
  latitude: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  longitude: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  timeZone: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DayAvailabilityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DayAvailability'] = ResolversParentTypes['DayAvailability']
> = ResolversObject<{
  available: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  date: Resolver<Maybe<ResolversTypes['LocalDate']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DayTimePeriodResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DayTimePeriod'] = ResolversParentTypes['DayTimePeriod']
> = ResolversObject<{
  endTime: Resolver<
    Maybe<ResolversTypes['LocalTime']>,
    ParentType,
    ContextType
  >;
  id: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  startTime: Resolver<
    Maybe<ResolversTypes['LocalTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DealerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Dealer'] = ResolversParentTypes['Dealer']
> = ResolversObject<{
  address: Resolver<
    Maybe<ResolversTypes['DealerAddress']>,
    ParentType,
    ContextType
  >;
  booking: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  companyId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  computedName: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  contacts: Resolver<
    Maybe<ResolversTypes['DealerContacts']>,
    ParentType,
    ContextType
  >;
  departmentClosingPeriods: Resolver<
    Maybe<ResolversTypes['Object']>,
    ParentType,
    ContextType
  >;
  departmentSchedules: Resolver<
    Maybe<ResolversTypes['Object']>,
    ParentType,
    ContextType
  >;
  id: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DealerAddressResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DealerAddress'] = ResolversParentTypes['DealerAddress']
> = ResolversObject<{
  computedAddress: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  coordinates: Resolver<
    Maybe<ResolversTypes['Coordinates']>,
    ParentType,
    ContextType
  >;
  city: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  distance: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DealerContactsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DealerContacts'] = ResolversParentTypes['DealerContacts']
> = ResolversObject<{
  email: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phone: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DealerSearchResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DealerSearch'] = ResolversParentTypes['DealerSearch']
> = ResolversObject<{
  frontend: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DealerSearchMatchResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DealerSearchMatch'] = ResolversParentTypes['DealerSearchMatch']
> = ResolversObject<{
  dealers: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Dealer']>>>,
    ParentType,
    ContextType
  >;
  total: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DmoBookingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DMOBooking'] = ResolversParentTypes['DMOBooking']
> = ResolversObject<{
  active: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  minimumDuration: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  pickUpDelay: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  returnDelay: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  timeSlotInterval: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  whiteList: Resolver<
    Maybe<ResolversTypes['WhiteList']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type DriverLicenseNotificationsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['DriverLicenseNotifications'] = ResolversParentTypes['DriverLicenseNotifications']
> = ResolversObject<{
  active: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  unit: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weight: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EnergyEfficiencyResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['EnergyEfficiency'] = ResolversParentTypes['EnergyEfficiency']
> = ResolversObject<{
  visible: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type EngineResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Engine'] = ResolversParentTypes['Engine']
> = ResolversObject<{
  powerInHp: Resolver<
    Maybe<ResolversTypes['TechnicalMetric']>,
    ParentType,
    ContextType
  >;
  powerInKw: Resolver<
    Maybe<ResolversTypes['TechnicalMetric']>,
    ParentType,
    ContextType
  >;
  type: Resolver<Maybe<ResolversTypes['EngineType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FootNotesConfigurationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FootNotesConfiguration'] = ResolversParentTypes['FootNotesConfiguration']
> = ResolversObject<{
  frontend: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FormConfigurationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FormConfiguration'] = ResolversParentTypes['FormConfiguration']
> = ResolversObject<{
  frontend: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type FuelConsumptionMetricsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['FuelConsumptionMetrics'] = ResolversParentTypes['FuelConsumptionMetrics']
> = ResolversObject<{
  electric: Resolver<
    Maybe<ResolversTypes['TechnicalRangeMetric']>,
    ParentType,
    ContextType
  >;
  fossil: Resolver<
    Maybe<ResolversTypes['TechnicalRangeMetric']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ImagesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Images'] = ResolversParentTypes['Images']
> = ResolversObject<{
  defaultImage: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  fallbackImages: Resolver<
    Maybe<ResolversTypes['Object']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type InfoBannerConfigurationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['InfoBannerConfiguration'] = ResolversParentTypes['InfoBannerConfiguration']
> = ResolversObject<{
  frontend: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface LocalDateScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['LocalDate'], any> {
  name: 'LocalDate';
}

export interface LocalTimeScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['LocalTime'], any> {
  name: 'LocalTime';
}

export type LocationSuggestionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['LocationSuggestion'] = ResolversParentTypes['LocationSuggestion']
> = ResolversObject<{
  label: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  locationId: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  postalCode: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MaintenanceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Maintenance'] = ResolversParentTypes['Maintenance']
> = ResolversObject<{
  active: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MinimumDriverAgeNotificationsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['MinimumDriverAgeNotifications'] = ResolversParentTypes['MinimumDriverAgeNotifications']
> = ResolversObject<{
  active: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ModelResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Model'] = ResolversParentTypes['Model']
> = ResolversObject<{
  bodyStyleId: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  bodyStyleName: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  categories: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Category']>>>,
    ParentType,
    ContextType
  >;
  classId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  className: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fuelTypes: Resolver<
    Maybe<Array<Maybe<ResolversTypes['FuelType']>>>,
    ParentType,
    ContextType
  >;
  group: Resolver<Maybe<ResolversTypes['Group']>, ParentType, ContextType>;
  id: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  images: Resolver<Maybe<ResolversTypes['Images']>, ParentType, ContextType>;
  motorisations: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Motorisation']>>>,
    ParentType,
    ContextType
  >;
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  transmissions: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Transmission']>>>,
    ParentType,
    ContextType
  >;
  vehicleTypeOptions: Resolver<
    Maybe<Array<Maybe<ResolversTypes['VehicleType']>>>,
    ParentType,
    ContextType
  >;
  weightCategories: Resolver<
    Maybe<Array<Maybe<ResolversTypes['WeightCategory']>>>,
    ParentType,
    ContextType
  >;
  lifeCycle: Resolver<
    Maybe<ResolversTypes['LifeCycle']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ModelSelectionResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ModelSelection'] = ResolversParentTypes['ModelSelection']
> = ResolversObject<{
  carbonFootprint: Resolver<
    Maybe<ResolversTypes['CarbonFootprint']>,
    ParentType,
    ContextType
  >;
  frontend: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  onlineCode: Resolver<
    Maybe<ResolversTypes['OnlineCode']>,
    ParentType,
    ContextType
  >;
  whiteList: Resolver<
    Maybe<ResolversTypes['WhiteList']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ModelSeriesMapperResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ModelSeriesMapper'] = ResolversParentTypes['ModelSeriesMapper']
> = ResolversObject<{
  frontend: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MotorisationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Motorisation'] = ResolversParentTypes['Motorisation']
> = ResolversObject<{
  baumuster: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  booking: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  categories: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Category']>>>,
    ParentType,
    ContextType
  >;
  changeYear: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  co2Emission: Resolver<
    Maybe<ResolversTypes['TechnicalRangeMetric']>,
    ParentType,
    ContextType
  >;
  driveType: Resolver<
    Maybe<ResolversTypes['DriveType']>,
    ParentType,
    ContextType
  >;
  energyEfficiencyClass: Resolver<
    Maybe<ResolversTypes['Object']>,
    ParentType,
    ContextType
  >;
  engine: Resolver<Maybe<ResolversTypes['Engine']>, ParentType, ContextType>;
  fuelConsumption: Resolver<
    Maybe<ResolversTypes['FuelConsumptionMetrics']>,
    ParentType,
    ContextType
  >;
  fuelType: Resolver<
    Maybe<ResolversTypes['FuelType']>,
    ParentType,
    ContextType
  >;
  id: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  images: Resolver<Maybe<ResolversTypes['Images']>, ParentType, ContextType>;
  lifeCycle: Resolver<
    Maybe<ResolversTypes['LifeCycle']>,
    ParentType,
    ContextType
  >;
  modelSeriesId: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  modelYear: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  nationalSalesType: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  transmissions: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Transmission']>>>,
    ParentType,
    ContextType
  >;
  vehicleTypes: Resolver<
    Maybe<Array<Maybe<ResolversTypes['VehicleType']>>>,
    ParentType,
    ContextType
  >;
  weight: Resolver<Maybe<ResolversTypes['Weight']>, ParentType, ContextType>;
  weightCategory: Resolver<
    Maybe<ResolversTypes['WeightCategory']>,
    ParentType,
    ContextType
  >;
  wheelBase: Resolver<
    Maybe<ResolversTypes['WheelBase']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MutationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']
> = ResolversObject<{
  createRentalBooking: Resolver<
    Maybe<ResolversTypes['AppointmentStatusWrapper_BookingStatus']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationCreateRentalBookingArgs,
      'rentalBookingAppointmentAttempt'
    >
  >;
  createTestDriveBookingReschedule: Resolver<
    Maybe<ResolversTypes['AppointmentStatusWrapper_BookingStatus']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationCreateTestDriveBookingRescheduleArgs,
      'testDriveBookingReschedule'
    >
  >;
  createRequest: Resolver<
    Maybe<ResolversTypes['AppointmentStatusWrapper_RequestStatus']>,
    ParentType,
    ContextType,
    RequireFields<MutationCreateRequestArgs, 'testDriveRequestAttempt'>
  >;
  cancelRentalBooking: Resolver<
    Maybe<ResolversTypes['BookingAppointmentCancellation']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationCancelRentalBookingArgs,
      'bookingAppointmentCancellation'
    >
  >;
  cancelTestDriveBooking: Resolver<
    Maybe<ResolversTypes['BookingAppointmentCancellation']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationCancelTestDriveBookingArgs,
      'bookingAppointmentCancellation'
    >
  >;
  createTestDriveBooking: Resolver<
    Maybe<ResolversTypes['AppointmentStatusWrapper_BookingStatus']>,
    ParentType,
    ContextType,
    RequireFields<
      MutationCreateTestDriveBookingArgs,
      'testDriveBookingAppointmentAttempt'
    >
  >;
}>;

export interface ObjectScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['Object'], any> {
  name: 'Object';
}

export interface OffsetDateTimeScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['OffsetDateTime'], any> {
  name: 'OffsetDateTime';
}

export type OneDocResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OneDoc'] = ResolversParentTypes['OneDoc']
> = ResolversObject<{
  active: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  orgID: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OnlineCodeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OnlineCode'] = ResolversParentTypes['OnlineCode']
> = ResolversObject<{
  baumusterMatchPoints: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  bodyStyleMatchPoints: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  classMatchPoints: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  frontend: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  modelYearMatchPoints: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  visible: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OnlineCodeMatchResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['OnlineCodeMatch'] = ResolversParentTypes['OnlineCodeMatch']
> = ResolversObject<{
  model: Resolver<Maybe<ResolversTypes['Model']>, ParentType, ContextType>;
  motorisation: Resolver<
    Maybe<ResolversTypes['Motorisation']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PickMeUpFromHomeResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PickMeUpFromHome'] = ResolversParentTypes['PickMeUpFromHome']
> = ResolversObject<{
  active: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  radius: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PricingDetailsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['PricingDetails'] = ResolversParentTypes['PricingDetails']
> = ResolversObject<{
  currencyCode: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  deductibleAmount: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  includedMileage: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  numberOfDays: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pricePerKm: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  pricingCategoryName: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  totalGrossPrice: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  totalNetPrice: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  totalVatAmount: Resolver<
    Maybe<ResolversTypes['Float']>,
    ParentType,
    ContextType
  >;
  unlimitedMileage: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface PrivacyOptionsSetScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['PrivacyOptionsSet'], any> {
  name: 'PrivacyOptionsSet';
}

export type QueryResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']
> = ResolversObject<{
  rentPrices: Resolver<
    Maybe<ResolversTypes['PricingDetails']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryRentPricesArgs,
      | 'startDateTime'
      | 'dealerId'
      | 'countryCode'
      | 'vin'
      | 'context'
      | 'language'
      | 'endDateTime'
    >
  >;
  rentalBookings: Resolver<
    Maybe<ResolversTypes['AppointmentStatusWrapper_BookingStatus']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryRentalBookingsArgs,
      'countryCode' | 'context' | 'domain' | 'language' | 'id'
    >
  >;
  testDriveRequestsCalendar: Resolver<
    Maybe<Array<Maybe<ResolversTypes['TestDriveRequestDayAvailability']>>>,
    ParentType,
    ContextType,
    RequireFields<
      QueryTestDriveRequestsCalendarArgs,
      | 'endDate'
      | 'dealerId'
      | 'countryCode'
      | 'context'
      | 'domain'
      | 'language'
      | 'startDate'
    >
  >;
  models: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Model']>>>,
    ParentType,
    ContextType,
    RequireFields<
      QueryModelsArgs,
      | 'filter'
      | 'filterMotorisations'
      | 'countryCode'
      | 'context'
      | 'domain'
      | 'language'
      | 'category'
    >
  >;
  rentModels: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Model']>>>,
    ParentType,
    ContextType,
    RequireFields<
      QueryRentModelsArgs,
      'countryCode' | 'context' | 'domain' | 'language'
    >
  >;
  bookingTimeSlots: Resolver<
    Maybe<Array<Maybe<ResolversTypes['TimeSlot']>>>,
    ParentType,
    ContextType,
    RequireFields<
      QueryBookingTimeSlotsArgs,
      | 'dealerId'
      | 'countryCode'
      | 'context'
      | 'domain'
      | 'language'
      | 'vehicleId'
      | 'day'
    >
  >;
  rentVehicleCalendar: Resolver<
    Maybe<Array<Maybe<ResolversTypes['RentalDayAvailability']>>>,
    ParentType,
    ContextType,
    RequireFields<
      QueryRentVehicleCalendarArgs,
      | 'endDate'
      | 'dealerId'
      | 'countryCode'
      | 'context'
      | 'vin'
      | 'language'
      | 'startDate'
    >
  >;
  configurations: Resolver<
    Maybe<ResolversTypes['UiConfiguration']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryConfigurationsArgs,
      'domain' | 'context' | 'countryCode' | 'language'
    >
  >;
  dealers: Resolver<
    Maybe<ResolversTypes['Dealer']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryDealersArgs,
      'countryCode' | 'context' | 'domain' | 'language' | 'id'
    >
  >;
  testDriveBookingsTimeslots: Resolver<
    Maybe<ResolversTypes['BookingDurationTimeSlots']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryTestDriveBookingsTimeslotsArgs,
      | 'dealerId'
      | 'countryCode'
      | 'context'
      | 'domain'
      | 'language'
      | 'vehicleId'
      | 'day'
    >
  >;
  onlineCodes: Resolver<
    Maybe<ResolversTypes['OnlineCodeMatch']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryOnlineCodesArgs,
      'onlineCode' | 'countryCode' | 'context' | 'domain' | 'language'
    >
  >;
  users: Resolver<
    Maybe<ResolversTypes['CiasClaim']>,
    ParentType,
    ContextType,
    RequireFields<QueryUsersArgs, 'token'>
  >;
  usersEmail: Resolver<
    Maybe<ResolversTypes['CiasClaimByEmail']>,
    ParentType,
    ContextType,
    RequireFields<QueryUsersEmailArgs, 'email'>
  >;
  dealerSearch: Resolver<
    Maybe<ResolversTypes['DealerSearchMatch']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryDealerSearchArgs,
      | 'locationId'
      | 'countryCode'
      | 'language'
      | 'context'
      | 'domain'
      | 'radius'
      | 'pickMeUp'
    >
  >;
  userTestDriveRequests: Resolver<
    Maybe<Array<Maybe<ResolversTypes['TestDriveRequestConfirmation']>>>,
    ParentType,
    ContextType,
    RequireFields<
      QueryUserTestDriveRequestsArgs,
      'countryCode' | 'context' | 'domain' | 'language'
    >
  >;
  testDriveBookingSimilarVehiclesSearch: Resolver<
    Maybe<Array<Maybe<ResolversTypes['TestDriveVehicle']>>>,
    ParentType,
    ContextType,
    RequireFields<
      QueryTestDriveBookingSimilarVehiclesSearchArgs,
      | 'dealersId'
      | 'countryCode'
      | 'context'
      | 'domain'
      | 'language'
      | 'modelSeriesId'
    >
  >;
  userTestDriveBookings: Resolver<
    Maybe<Array<Maybe<ResolversTypes['BookingAppointmentConfirmation']>>>,
    ParentType,
    ContextType,
    RequireFields<
      QueryUserTestDriveBookingsArgs,
      'countryCode' | 'context' | 'domain' | 'language'
    >
  >;
  testDriveBookings: Resolver<
    Maybe<ResolversTypes['BookingAppointmentConfirmation']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryTestDriveBookingsArgs,
      'countryCode' | 'context' | 'domain' | 'language' | 'id'
    >
  >;
  motorisations: Resolver<
    Maybe<ResolversTypes['Motorisation']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryMotorisationsArgs,
      'countryCode' | 'context' | 'domain' | 'language' | 'id'
    >
  >;
  days: Resolver<
    Maybe<Array<Maybe<ResolversTypes['TestDriveDayAvailability']>>>,
    ParentType,
    ContextType,
    RequireFields<
      QueryDaysArgs,
      | 'includeBookingOptions'
      | 'wholesale'
      | 'endDate'
      | 'dealerId'
      | 'countryCode'
      | 'context'
      | 'domain'
      | 'language'
      | 'modelSeriesId'
      | 'startDate'
    >
  >;
  specificModel: Resolver<
    Maybe<ResolversTypes['Model']>,
    ParentType,
    ContextType,
    RequireFields<
      QuerySpecificModelArgs,
      | 'countryCode'
      | 'context'
      | 'domain'
      | 'language'
      | 'modelSeriesId'
      | 'archivedMotorisations'
    >
  >;
  testDriveBookingVehicleSearch: Resolver<
    Maybe<Array<Maybe<ResolversTypes['TestDriveVehicle']>>>,
    ParentType,
    ContextType,
    RequireFields<
      QueryTestDriveBookingVehicleSearchArgs,
      | 'endDate'
      | 'dealersId'
      | 'countryCode'
      | 'context'
      | 'domain'
      | 'language'
      | 'startDate'
      | 'modelSeriesId'
    >
  >;
  testDriveBookingVehicleSearchWithinRadius: Resolver<
    Maybe<ResolversTypes['TestDriveBookingVehicleDealer']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryTestDriveBookingVehicleSearchWithinRadiusArgs,
      | 'countryCode'
      | 'context'
      | 'domain'
      | 'language'
      | 'modelSeriesId'
      | 'radius'
      | 'pickMeUp'
    >
  >;
  testDriveBookingVehicleSearchFixedDealer: Resolver<
    Maybe<ResolversTypes['TestDriveBookingVehicleDealer']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryTestDriveBookingVehicleSearchFixedDealerArgs,
      | 'countryCode'
      | 'context'
      | 'domain'
      | 'language'
      | 'modelSeriesId'
      | 'dealerId'
      | 'pickMeUp'
    >
  >;
  testDriveBookingsCalendar: Resolver<
    Maybe<Array<Maybe<ResolversTypes['TestDriveBookingDayAvailability']>>>,
    ParentType,
    ContextType,
    RequireFields<
      QueryTestDriveBookingsCalendarArgs,
      | 'endDate'
      | 'dealerId'
      | 'countryCode'
      | 'context'
      | 'domain'
      | 'language'
      | 'vehicleId'
      | 'startDate'
    >
  >;
  suggestions: Resolver<
    Maybe<Array<Maybe<ResolversTypes['LocationSuggestion']>>>,
    ParentType,
    ContextType,
    RequireFields<QuerySuggestionsArgs, 'countryCode' | 'address'>
  >;
  suggestionsPostalCode: Resolver<
    Maybe<Array<Maybe<ResolversTypes['LocationSuggestion']>>>,
    ParentType,
    ContextType,
    RequireFields<QuerySuggestionsPostalCodeArgs, 'countryCode' | 'postalCode'>
  >;
  rentVehicleSearch: Resolver<
    Maybe<ResolversTypes['TestDriveBookingVehicleDealer']>,
    ParentType,
    ContextType,
    RequireFields<
      QueryRentVehicleSearchArgs,
      | 'domain'
      | 'context'
      | 'countryCode'
      | 'language'
      | 'startDateTime'
      | 'endDateTime'
      | 'locationId'
      | 'radius'
      | 'searchProfileName'
      | 'pickMeUp'
    >
  >;
  testDriveDealers: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType,
    RequireFields<
      QueryTestDriveDealersArgs,
      'countryCode' | 'language' | 'modelSeriesId'
    >
  >;
}>;

export type RentalDayAvailabilityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RentalDayAvailability'] = ResolversParentTypes['RentalDayAvailability']
> = ResolversObject<{
  available: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  businessHoursPeriods: Resolver<
    Maybe<Array<Maybe<ResolversTypes['BusinessHoursPeriod']>>>,
    ParentType,
    ContextType
  >;
  date: Resolver<Maybe<ResolversTypes['LocalDate']>, ParentType, ContextType>;
  dealerOpen: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  zoneOffSet: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RequestSchedulePreferenceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RequestSchedulePreference'] = ResolversParentTypes['RequestSchedulePreference']
> = ResolversObject<{
  dayPeriod: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  pickUpDateStr: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  pickUpDateTime: Resolver<
    Maybe<ResolversTypes['OffsetDateTime']>,
    ParentType,
    ContextType
  >;
  returnDateStr: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  returnDateTime: Resolver<
    Maybe<ResolversTypes['OffsetDateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RequestTimeSlotResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['RequestTimeSlot'] = ResolversParentTypes['RequestTimeSlot']
> = ResolversObject<{
  available: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  end: Resolver<
    Maybe<ResolversTypes['OffsetDateTime']>,
    ParentType,
    ContextType
  >;
  periodId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  start: Resolver<
    Maybe<ResolversTypes['OffsetDateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SchedulePreferenceResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SchedulePreference'] = ResolversParentTypes['SchedulePreference']
> = ResolversObject<{
  pickUpDateStr: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  pickUpDateTime: Resolver<
    Maybe<ResolversTypes['OffsetDateTime']>,
    ParentType,
    ContextType
  >;
  returnDateStr: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  returnDateTime: Resolver<
    Maybe<ResolversTypes['OffsetDateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface SetScalarConfig
  extends GraphQLScalarTypeConfig<ResolversTypes['Set'], any> {
  name: 'Set';
}

export type SharedNotificationsResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SharedNotifications'] = ResolversParentTypes['SharedNotifications']
> = ResolversObject<{
  driverLicenseNotifications: Resolver<
    Maybe<ResolversTypes['DriverLicenseNotifications']>,
    ParentType,
    ContextType
  >;
  minimumDriverAgeNotifications: Resolver<
    Maybe<ResolversTypes['MinimumDriverAgeNotifications']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SimilarVehiclesResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SimilarVehicles'] = ResolversParentTypes['SimilarVehicles']
> = ResolversObject<{
  active: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  similarVehiclesCriteria: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  similarVehiclesSuggestions: Resolver<
    Maybe<ResolversTypes['Object']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type SummaryConfigurationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['SummaryConfiguration'] = ResolversParentTypes['SummaryConfiguration']
> = ResolversObject<{
  frontend: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TechnicalMetricResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TechnicalMetric'] = ResolversParentTypes['TechnicalMetric']
> = ResolversObject<{
  unit: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TechnicalRangeMetricResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TechnicalRangeMetric'] = ResolversParentTypes['TechnicalRangeMetric']
> = ResolversObject<{
  individual: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  max: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  min: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  unit: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TestDriveBookingDayAvailabilityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestDriveBookingDayAvailability'] = ResolversParentTypes['TestDriveBookingDayAvailability']
> = ResolversObject<{
  available: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  date: Resolver<Maybe<ResolversTypes['LocalDate']>, ParentType, ContextType>;
  dealerOpen: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TestDriveBookingVehicleDealerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestDriveBookingVehicleDealer'] = ResolversParentTypes['TestDriveBookingVehicleDealer']
> = ResolversObject<{
  bookings: Resolver<
    Maybe<Array<Maybe<ResolversTypes['TestDriveVehicle']>>>,
    ParentType,
    ContextType
  >;
  dealers: Resolver<
    Maybe<Array<Maybe<ResolversTypes['Dealer']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TestDriveDayAvailabilityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestDriveDayAvailability'] = ResolversParentTypes['TestDriveDayAvailability']
> = ResolversObject<{
  available: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  bookingOptions: Resolver<
    Maybe<Array<Maybe<ResolversTypes['BookingOption']>>>,
    ParentType,
    ContextType
  >;
  date: Resolver<Maybe<ResolversTypes['LocalDate']>, ParentType, ContextType>;
  requestTimeSlots: Resolver<
    Maybe<Array<Maybe<ResolversTypes['TimeSlot']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TestDriveRequestConfirmationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestDriveRequestConfirmation'] = ResolversParentTypes['TestDriveRequestConfirmation']
> = ResolversObject<{
  appointmentMessage: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  countryCode: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  dealer: Resolver<Maybe<ResolversTypes['Dealer']>, ParentType, ContextType>;
  fuelType: Resolver<
    Maybe<ResolversTypes['FuelType']>,
    ParentType,
    ContextType
  >;
  id: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  language: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  model: Resolver<Maybe<ResolversTypes['Model']>, ParentType, ContextType>;
  motorisation: Resolver<
    Maybe<ResolversTypes['Motorisation']>,
    ParentType,
    ContextType
  >;
  schedule: Resolver<
    Maybe<ResolversTypes['RequestSchedulePreference']>,
    ParentType,
    ContextType
  >;
  status: Resolver<
    Maybe<ResolversTypes['RequestStatus']>,
    ParentType,
    ContextType
  >;
  transmission: Resolver<
    Maybe<ResolversTypes['Transmission']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TestDriveRequestDayAvailabilityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestDriveRequestDayAvailability'] = ResolversParentTypes['TestDriveRequestDayAvailability']
> = ResolversObject<{
  available: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  date: Resolver<Maybe<ResolversTypes['LocalDate']>, ParentType, ContextType>;
  dealerOpen: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  requestTimeSlots: Resolver<
    Maybe<Array<Maybe<ResolversTypes['RequestTimeSlot']>>>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TestDriveVehicleResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TestDriveVehicle'] = ResolversParentTypes['TestDriveVehicle']
> = ResolversObject<{
  baumuster: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  booking: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  co2Emission: Resolver<
    Maybe<ResolversTypes['TechnicalRangeMetric']>,
    ParentType,
    ContextType
  >;
  dealerId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  energyEfficiencyClass: Resolver<
    Maybe<ResolversTypes['ValuedEnumWrapper_EnergyEfficiencyClass']>,
    ParentType,
    ContextType
  >;
  engine: Resolver<Maybe<ResolversTypes['Engine']>, ParentType, ContextType>;
  fuelConsumption: Resolver<
    Maybe<ResolversTypes['FuelConsumptionMetrics']>,
    ParentType,
    ContextType
  >;
  timePeriodAvailability: Resolver<
    Maybe<ResolversTypes['TimePeriodAvailability']>,
    ParentType,
    ContextType
  >;
  fuelType: Resolver<
    Maybe<ResolversTypes['FuelType']>,
    ParentType,
    ContextType
  >;
  id: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  images: Resolver<Maybe<ResolversTypes['Images']>, ParentType, ContextType>;
  minimumDriverAge: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  modelName: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  modelSeriesId: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  motorisationId: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  registration: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  registrationDate: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  requiredDrivingLicenceCategory: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  transmission: Resolver<
    Maybe<ResolversTypes['Transmission']>,
    ParentType,
    ContextType
  >;
  vehicleTypes: Resolver<
    Maybe<Array<Maybe<ResolversTypes['VehicleType']>>>,
    ParentType,
    ContextType
  >;
  vin: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  weightCategory: Resolver<
    Maybe<ResolversTypes['WeightCategory']>,
    ParentType,
    ContextType
  >;
  classId: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bodyStyleId: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  pricingDetails: Resolver<
    Maybe<ResolversTypes['PricingDetails']>,
    ParentType,
    ContextType
  >;
  numberOfSeats: Resolver<
    Maybe<ResolversTypes['Int']>,
    ParentType,
    ContextType
  >;
  navigationSystem: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  trailerhitch: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  heatedseats: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  wintertyres: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  parkingcamera: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  allWheelDrive: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  airCondition: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  mbux: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  sunRoof: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  cruiseControl: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  luggage: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TimePeriodAvailabilityResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimePeriodAvailability'] = ResolversParentTypes['TimePeriodAvailability']
> = ResolversObject<{
  morning: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  afternoon: Resolver<
    Maybe<ResolversTypes['Boolean']>,
    ParentType,
    ContextType
  >;
  evening: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TimePickerResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimePicker'] = ResolversParentTypes['TimePicker']
> = ResolversObject<{
  bookingTimeslotInterval: Resolver<
    ResolversTypes['Int'],
    ParentType,
    ContextType
  >;
  dayTimePeriods: Resolver<
    Maybe<Array<Maybe<ResolversTypes['DayTimePeriod']>>>,
    ParentType,
    ContextType
  >;
  schedule: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  timeSlotDuration: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TimeSlotResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimeSlot'] = ResolversParentTypes['TimeSlot']
> = ResolversObject<{
  available: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  end: Resolver<
    Maybe<ResolversTypes['OffsetDateTime']>,
    ParentType,
    ContextType
  >;
  start: Resolver<
    Maybe<ResolversTypes['OffsetDateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TimeSlotIntervalResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TimeSlotInterval'] = ResolversParentTypes['TimeSlotInterval']
> = ResolversObject<{
  end: Resolver<
    Maybe<ResolversTypes['OffsetDateTime']>,
    ParentType,
    ContextType
  >;
  start: Resolver<
    Maybe<ResolversTypes['OffsetDateTime']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TrackingInfoResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['TrackingInfo'] = ResolversParentTypes['TrackingInfo']
> = ResolversObject<{
  sendTrackingInfo: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  trackingParameterKeyValueSplitter: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  trackingParameterSplitter: Resolver<
    Maybe<ResolversTypes['String']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UiBookingResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UiBooking'] = ResolversParentTypes['UiBooking']
> = ResolversObject<{
  bookingActive: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  dmoBooking: Resolver<
    Maybe<ResolversTypes['DMOBooking']>,
    ParentType,
    ContextType
  >;
  forceBookingOnly: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  rescheduleActive: Resolver<
    ResolversTypes['Boolean'],
    ParentType,
    ContextType
  >;
  similarVehicles: Resolver<
    Maybe<ResolversTypes['SimilarVehicles']>,
    ParentType,
    ContextType
  >;
  trackingInfo: Resolver<
    Maybe<ResolversTypes['TrackingInfo']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UiConfigurationResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['UiConfiguration'] = ResolversParentTypes['UiConfiguration']
> = ResolversObject<{
  aemFormsHandlerConfig: Resolver<
    Maybe<ResolversTypes['AemFormsHandlerConfig']>,
    ParentType,
    ContextType
  >;
  aemFormsResources: Resolver<
    Maybe<ResolversTypes['AemFormsResourcesConfiguration']>,
    ParentType,
    ContextType
  >;
  booking: Resolver<
    Maybe<ResolversTypes['UiBooking']>,
    ParentType,
    ContextType
  >;
  calendar: Resolver<
    Maybe<ResolversTypes['AppointmentCalendar']>,
    ParentType,
    ContextType
  >;
  cancellationForm: Resolver<
    Maybe<ResolversTypes['FormConfiguration']>,
    ParentType,
    ContextType
  >;
  contactForm: Resolver<
    Maybe<ResolversTypes['FormConfiguration']>,
    ParentType,
    ContextType
  >;
  countryHub: Resolver<
    Maybe<Array<Maybe<ResolversTypes['String']>>>,
    ParentType,
    ContextType
  >;
  dealerSearch: Resolver<
    Maybe<ResolversTypes['DealerSearch']>,
    ParentType,
    ContextType
  >;
  footNotes: Resolver<
    Maybe<ResolversTypes['FootNotesConfiguration']>,
    ParentType,
    ContextType
  >;
  infoBanner: Resolver<
    Maybe<ResolversTypes['InfoBannerConfiguration']>,
    ParentType,
    ContextType
  >;
  labels: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  links: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  maintenance: Resolver<
    Maybe<ResolversTypes['Maintenance']>,
    ParentType,
    ContextType
  >;
  modelSelection: Resolver<
    Maybe<ResolversTypes['ModelSelection']>,
    ParentType,
    ContextType
  >;
  modelSeriesMapper: Resolver<
    Maybe<ResolversTypes['ModelSeriesMapper']>,
    ParentType,
    ContextType
  >;
  oneDoc: Resolver<Maybe<ResolversTypes['OneDoc']>, ParentType, ContextType>;
  pickMeUpFromHome: Resolver<
    Maybe<ResolversTypes['PickMeUpFromHome']>,
    ParentType,
    ContextType
  >;
  scheduleForm: Resolver<
    Maybe<ResolversTypes['FormConfiguration']>,
    ParentType,
    ContextType
  >;
  sharedNotifications: Resolver<
    Maybe<ResolversTypes['SharedNotifications']>,
    ParentType,
    ContextType
  >;
  summary: Resolver<
    Maybe<ResolversTypes['SummaryConfiguration']>,
    ParentType,
    ContextType
  >;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ValuedEnumWrapper_EnergyEfficiencyClassResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['ValuedEnumWrapper_EnergyEfficiencyClass'] = ResolversParentTypes['ValuedEnumWrapper_EnergyEfficiencyClass']
> = ResolversObject<{
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  value: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WeightResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['Weight'] = ResolversParentTypes['Weight']
> = ResolversObject<{
  maximum: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  unloaded: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WheelBaseResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['WheelBase'] = ResolversParentTypes['WheelBase']
> = ResolversObject<{
  id: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  name: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type WhiteListResolvers<
  ContextType = any,
  ParentType extends ResolversParentTypes['WhiteList'] = ResolversParentTypes['WhiteList']
> = ResolversObject<{
  active: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  frontend: Resolver<Maybe<ResolversTypes['Object']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = any> = ResolversObject<{
  AemFormsHandlerConfig: AemFormsHandlerConfigResolvers<ContextType>;
  AemFormsResourcesConfiguration: AemFormsResourcesConfigurationResolvers<ContextType>;
  AppointmentCalendar: AppointmentCalendarResolvers<ContextType>;
  AppointmentStatusWrapper_BookingStatus: AppointmentStatusWrapper_BookingStatusResolvers<ContextType>;
  AppointmentStatusWrapper_RequestStatus: AppointmentStatusWrapper_RequestStatusResolvers<ContextType>;
  BookingAppointmentCancellation: BookingAppointmentCancellationResolvers<ContextType>;
  BookingAppointmentConfirmation: BookingAppointmentConfirmationResolvers<ContextType>;
  BookingDuration: BookingDurationResolvers<ContextType>;
  BookingDurationTimeSlots: BookingDurationTimeSlotsResolvers<ContextType>;
  BookingOption: BookingOptionResolvers<ContextType>;
  BusinessHoursPeriod: BusinessHoursPeriodResolvers<ContextType>;
  CarbonFootprint: CarbonFootprintResolvers<ContextType>;
  CiasClaim: CiasClaimResolvers<ContextType>;
  CiasClaimByEmail: CiasClaimByEmailResolvers<ContextType>;
  ClosingDatePeriod: ClosingDatePeriodResolvers<ContextType>;
  Co2EmissionAndFuelConsumption: Co2EmissionAndFuelConsumptionResolvers<ContextType>;
  Coordinates: CoordinatesResolvers<ContextType>;
  DayAvailability: DayAvailabilityResolvers<ContextType>;
  DayTimePeriod: DayTimePeriodResolvers<ContextType>;
  Dealer: DealerResolvers<ContextType>;
  DealerAddress: DealerAddressResolvers<ContextType>;
  DealerContacts: DealerContactsResolvers<ContextType>;
  DealerSearch: DealerSearchResolvers<ContextType>;
  DealerSearchMatch: DealerSearchMatchResolvers<ContextType>;
  DMOBooking: DmoBookingResolvers<ContextType>;
  DriverLicenseNotifications: DriverLicenseNotificationsResolvers<ContextType>;
  EnergyEfficiency: EnergyEfficiencyResolvers<ContextType>;
  Engine: EngineResolvers<ContextType>;
  FootNotesConfiguration: FootNotesConfigurationResolvers<ContextType>;
  FormConfiguration: FormConfigurationResolvers<ContextType>;
  FuelConsumptionMetrics: FuelConsumptionMetricsResolvers<ContextType>;
  Images: ImagesResolvers<ContextType>;
  InfoBannerConfiguration: InfoBannerConfigurationResolvers<ContextType>;
  LocalDate: GraphQLScalarType;
  LocalTime: GraphQLScalarType;
  LocationSuggestion: LocationSuggestionResolvers<ContextType>;
  Maintenance: MaintenanceResolvers<ContextType>;
  MinimumDriverAgeNotifications: MinimumDriverAgeNotificationsResolvers<ContextType>;
  Model: ModelResolvers<ContextType>;
  ModelSelection: ModelSelectionResolvers<ContextType>;
  ModelSeriesMapper: ModelSeriesMapperResolvers<ContextType>;
  Motorisation: MotorisationResolvers<ContextType>;
  Mutation: MutationResolvers<ContextType>;
  Object: GraphQLScalarType;
  OffsetDateTime: GraphQLScalarType;
  OneDoc: OneDocResolvers<ContextType>;
  OnlineCode: OnlineCodeResolvers<ContextType>;
  OnlineCodeMatch: OnlineCodeMatchResolvers<ContextType>;
  PickMeUpFromHome: PickMeUpFromHomeResolvers<ContextType>;
  PricingDetails: PricingDetailsResolvers<ContextType>;
  PrivacyOptionsSet: GraphQLScalarType;
  Query: QueryResolvers<ContextType>;
  RentalDayAvailability: RentalDayAvailabilityResolvers<ContextType>;
  RequestSchedulePreference: RequestSchedulePreferenceResolvers<ContextType>;
  RequestTimeSlot: RequestTimeSlotResolvers<ContextType>;
  SchedulePreference: SchedulePreferenceResolvers<ContextType>;
  Set: GraphQLScalarType;
  SharedNotifications: SharedNotificationsResolvers<ContextType>;
  SimilarVehicles: SimilarVehiclesResolvers<ContextType>;
  SummaryConfiguration: SummaryConfigurationResolvers<ContextType>;
  TechnicalMetric: TechnicalMetricResolvers<ContextType>;
  TechnicalRangeMetric: TechnicalRangeMetricResolvers<ContextType>;
  TestDriveBookingDayAvailability: TestDriveBookingDayAvailabilityResolvers<ContextType>;
  TestDriveBookingVehicleDealer: TestDriveBookingVehicleDealerResolvers<ContextType>;
  TestDriveDayAvailability: TestDriveDayAvailabilityResolvers<ContextType>;
  TestDriveRequestConfirmation: TestDriveRequestConfirmationResolvers<ContextType>;
  TestDriveRequestDayAvailability: TestDriveRequestDayAvailabilityResolvers<ContextType>;
  TestDriveVehicle: TestDriveVehicleResolvers<ContextType>;
  TimePeriodAvailability: TimePeriodAvailabilityResolvers<ContextType>;
  TimePicker: TimePickerResolvers<ContextType>;
  TimeSlot: TimeSlotResolvers<ContextType>;
  TimeSlotInterval: TimeSlotIntervalResolvers<ContextType>;
  TrackingInfo: TrackingInfoResolvers<ContextType>;
  UiBooking: UiBookingResolvers<ContextType>;
  UiConfiguration: UiConfigurationResolvers<ContextType>;
  ValuedEnumWrapper_EnergyEfficiencyClass: ValuedEnumWrapper_EnergyEfficiencyClassResolvers<ContextType>;
  Weight: WeightResolvers<ContextType>;
  WheelBase: WheelBaseResolvers<ContextType>;
  WhiteList: WhiteListResolvers<ContextType>;
}>;

/**
 * @deprecated
 * Use "Resolvers" root object instead. If you wish to get "IResolvers", add "typesPrefix: I" to your config.
 */
export type IResolvers<ContextType = any> = Resolvers<ContextType>;
export type DirectiveResolvers<ContextType = any> = ResolversObject<{
  defer: DeferDirectiveResolver<any, any, ContextType>;
  oneOf: OneOfDirectiveResolver<any, any, ContextType>;
  specifiedBy: SpecifiedByDirectiveResolver<any, any, ContextType>;
}>;

/**
 * @deprecated
 * Use "DirectiveResolvers" root object instead. If you wish to get "IDirectiveResolvers", add "typesPrefix: I" to your config.
 */
export type IDirectiveResolvers<ContextType = any> =
  DirectiveResolvers<ContextType>;
